//TEXTOS DE BARRA PROMOCIONAL
export const promotionalText = {
  id: 'beta-frelia-2025', // para recordar el cierre en localStorage
  es: {
    text: '¿Listo para trabajar con un experto virtual? Prueba Frelia y lleva tus proyectos al siguiente nivel.',
    linkText: '¡Únete a la beta hoy!',
    linkUrl: 'https://t.me/Make_test_frenkel_bot'
  },
  en: {
    text: 'Ready to work with a virtual expert? Try Frelia and take your projects to the next level.',
    linkText: 'Join the beta today!',
    linkUrl: 'https://t.me/Make_test_frenkel_bot'
  },
  de: {
    text: 'Bereit, mit einem virtuellen Experten zu arbeiten? Teste Frelia und bring deine Projekte aufs nächste Level.',
    linkText: 'Tritt der Beta heute bei!',
    linkUrl: 'https://t.me/Make_test_frenkel_bot'
  },
  // fallback global (por si alguna key por idioma no trae link)
  linkUrl: 'https://t.me/Make_test_frenkel_bot'
};

//TEXTOS MENÚ DE NAVEGACIÓN
export const navLabels = {
  es: {
    menuTitle: 'Menú',
    items: [
      { path: '/', label: 'Inicio' },
      { path: '/nosotros', label: 'Nosotros' },
      { path: '/beneficios', label: 'Beneficios' },
      { path: '/servicios', label: 'Servicios' },
      { path: '/capacitacion', label: 'Capacitación' },
      { path: '/contacto', label: 'Contacto' },
      { path: '/blog', label: 'Blog' },
      { path: '/casosdeexito', label: 'Casos de Éxito' }
    ]
  },
  en: {
    menuTitle: 'Menu',
    items: [
      { path: '/', label: 'Home' },
      { path: '/nosotros', label: 'About Us' },
      { path: '/beneficios', label: 'Benefits' },
      { path: '/servicios', label: 'Services' },
      { path: '/capacitacion', label: 'Training' },
      { path: '/contacto', label: 'Contact' },
      { path: '/blog', label: 'Blog' },
      { path: '/casosdeexito', label: 'Casos de Éxito' }
    ]
  },
  de: {
    menuTitle: 'Menü',
    items: [
      { path: '/', label: 'Startseite' },
      { path: '/nosotros', label: 'Über uns' },
      { path: '/beneficios', label: 'Vorteile' },
      { path: '/servicios', label: 'Dienstleistungen' },
      { path: '/capacitacion', label: 'Schulungen' },
      { path: '/contacto', label: 'Kontakt' },
      { path: '/blog', label: 'Blog' },
      { path: '/casosdeexito', label: 'Casos de Éxito' }
    ]
  }
};

// TEXTOS DE CARRUSEL
export const carruselItems = [
  {
    image: new URL('@/assets/images/banner01.png', import.meta.url).href,
    link: '/industria-4-0',
    content: {
      es: {
        title: 'Digitaliza tu planta y lidera la revolución de la Industria 4.0',
        text: 'Optimiza procesos, conecta tus equipos y toma decisiones basadas en datos con soluciones integrales de transformación industrial.',
        button: 'SABER MÁS'
      },
      en: {
        title: 'Digitize Your Plant and Lead the Industry 4.0 Revolution',
        text: 'Optimize processes, connect your systems, and make data-driven decisions with end-to-end industrial transformation solutions.',
        button: 'LEARN MORE'
      },
      de: {
        title: 'Digitalisieren Sie Ihre Anlage und führen Sie die Industrie 4.0-Revolution an',
        text: 'Optimieren Sie Prozesse, vernetzen Sie Ihre Systeme und treffen Sie datenbasierte Entscheidungen mit ganzheitlichen Lösungen für die industrielle Transformation.',
        button: 'MEHR ERFAHREN'
      }
    }
  },
  {
    image: new URL('@/assets/images/banner02.png', import.meta.url).href,
    link: '/capacitacion',
    content: {
      es: {
        title: 'Impulsa a tu Equipo. Domina la Industria.',
        text: 'Capacitación ejecutiva en sistemas, automatización y transformación digital. Desarrolla talento líder para enfrentar cualquier reto tecnológico y destacar en cualquier sector.',
        button: 'DESCUBRIR CAPACITACIÓN'
      },
      en: {
        title: 'Empower Your Team. Master the Industry.',
        text: 'Executive training in systems, automation, and digital transformation. Develop top talent ready to tackle any technological challenge and excel in every sector.',
        button: 'DISCOVER TRAINING'
      },
      de: {
        title: 'Stärken Sie Ihr Team. Beherrschen Sie die Branche.',
        text: 'Executive-Schulungen in Systemen, Automatisierung und digitaler Transformation. Entwickeln Sie Talente, die jede technologische Herausforderung meistern und in jedem Bereich glänzen.',
        button: 'SCHULUNGEN ENTDECKEN'
      }
    }
  },
  {
    image: new URL('@/assets/images/banner03.png', import.meta.url).href,
    link: '/servicios',
    content: {
      es: {
        title: 'Descubre el Ecosistema Frenkel',
        text: 'Soluciones integrales para transformar cualquier industria: método propio, automatización, capacitación y tecnología de vanguardia para empresas de todos los sectores.',
        button: 'CONOCER SOLUCIONES'
      },
      en: {
        title: 'Discover the Frenkel Ecosystem',
        text: 'Comprehensive solutions to transform any industry: our unique method, automation, training, and cutting-edge technology for companies in every sector.',
        button: 'EXPLORE SOLUTIONS'
      },
      de: {
        title: 'Entdecken Sie das Frenkel-Ökosystem',
        text: 'Ganzheitliche Lösungen für jede Branche: eigene Methode, Automatisierung, Schulungen und modernste Technologie – für Unternehmen aller Sektoren.',
        button: 'LÖSUNGEN ENTDECKEN'
      }
    }
  }
];

// INFORMACION DE NOSOTROS
export const aboutSection = {
  es: {
    title: '¿Qué es FRENKEL?',
    video: new URL('@/assets/video/video_esp.mp4', import.meta.url).href,
    button: 'SABER MÁS'
  },
  en: {
    title: 'What is FRENKEL?',
    video: new URL('@/assets/video/video_eng.mp4', import.meta.url).href,
    button: 'LEARN MORE'
  },
  de: {
    title: 'Was ist FRENKEL?',
    video: new URL('@/assets/video/video_deu.mp4', import.meta.url).href,
    button: 'MEHR ERFAHREN'
  },
  link: '/nosotros'
};

// INFORMACIÓN DE POR QUÉ CONTRATAR A FRENKEL
export const whyFrenkel = {
  es: {
    title: '¿Por qué contratar a FRENKEL?',
    text1:
      'Frenkel Engineering es el aliado estratégico que necesitas para transformar digitalmente tu industria. Somos pioneros en la integración de análisis de datos en tiempo real, IIoT, inteligencia artificial y machine learning, lo que nos permite optimizar procesos, reducir desperdicios y maximizar la eficiencia operativa.',
    text2:
      'Con certificaciones y reconocimientos destacados, y un enfoque humano en cada proyecto, ayudamos a tu empresa a tomar decisiones informadas y a crear un futuro más eficiente y sustentable.',
    quote: '"Frenkel Engineering: Ingeniería que piensa, conecta y transforma."'
  },
  en: {
    title: 'Why hire FRENKEL?',
    text1:
      'Frenkel Engineering is the strategic ally you need to digitally transform your industry. We are pioneers in integrating real-time data analytics, IIoT, artificial intelligence, and machine learning—enabling us to optimize processes, reduce waste, and maximize operational efficiency.',
    text2:
      'With distinguished certifications and recognitions, and a human-centered approach in every project, we help your company make informed decisions and build a more efficient and sustainable future.',
    quote: '"Frenkel Engineering: Engineering that thinks, connects, and transforms."'
  },
  de: {
    title: 'Warum FRENKEL beauftragen?',
    text1:
      'Frenkel Engineering ist der strategische Partner, den Sie benötigen, um Ihre Industrie digital zu transformieren. Wir sind Vorreiter in der Integration von Echtzeit-Datenanalyse, IIoT, künstlicher Intelligenz und maschinellem Lernen – dadurch optimieren wir Prozesse, reduzieren Verschwendung und maximieren die operative Effizienz.',
    text2:
      'Mit anerkannten Zertifizierungen und Auszeichnungen sowie einem menschlichen Ansatz in jedem Projekt helfen wir Ihrem Unternehmen, fundierte Entscheidungen zu treffen und eine effizientere und nachhaltigere Zukunft zu gestalten.',
    quote: '"Frenkel Engineering: Ingenieurwesen, das denkt, verbindet und transformiert."'
  }
};
// INFORMACIÓN DE SECCIÓN TRAINING SEASON
export const trainingSection = {
  es: {
    title: 'Temporada de Capacitación',
    description:
      'Todos nuestros cursos están disponibles en formato remoto y presencial. Personaliza tu experiencia formativa combinando diferentes cursos. Para más información ¡Contáctanos!',
    button: 'DESCUBRIR PROGRAMAS',
    link: '/capacitacion'
  },
  en: {
    title: 'Training Season',
    description:
      'All our courses are available in both remote and in-person formats. Customize your learning experience by combining different courses. For more information, contact us!',
    button: 'EXPLORE PROGRAMS',
    link: '/capacitacion'
  },
  de: {
    title: 'Schulungssaison',
    description:
      'Alle unsere Kurse sind sowohl im Fern- als auch im Präsenzformat verfügbar. Passen Sie Ihr Lernerlebnis an, indem Sie verschiedene Kurse kombinieren. Für weitere Informationen kontaktieren Sie uns!',
    button: 'PROGRAMME ENTDECKEN',
    link: '/capacitacion'
  }
};

export const latestNewsSection = {
  es: {
    title: 'Últimas noticias',
    readMore: 'Leer más',
    readAll: 'Ver todas las noticias',
    allLink: '/blog',
    description: 'Entérate de las novedades más recientes de nuestra empresa.'
  },
  en: {
    title: 'Latest News',
    readMore: 'Read more',
    readAll: 'View all news',
    allLink: '/blog',
    description: 'Stay up to date with our latest updates and articles.'
  },
  de: {
    title: 'Neueste Nachrichten',
    readMore: 'Mehr erfahren',
    readAll: 'Alle Nachrichten anzeigen',
    allLink: '/blog',
    description: 'Bleiben Sie über unsere neuesten Nachrichten informiert.'
  }
};
export const footerContent = {
  es: {
    phrase: "Soluciones que transforman tu industria.",
    columns: {
      services: [
        { label: "Industria 4.0", url: "/industria-4-0" },
        { label: "Consultoría y Asesoría", url: "/consultoria-asesoria-ingenieria" },
        { label: "Automatización y Control", url: "/automatizacion-de-control" },
       
      ],
      links: [
        { label: "Nosotros", url: "/nosotros" },
        { label: "Capacitación", url: "/capacitacion" },
        { label: "Casos de Éxito", url: "/casosdeexito" },
        { label: "Blog", url: "/blog" },
        { label: "Contacto", url: "/contacto" }
      ],
      contact: {
        phones: ["52 55 3996 0462", "52 33 3900 8533", "52 55 9186 3622"],
        email: "admon@frenkel.com.mx",
        hours: "Horario de atención: 9:00 a 18:00"
      }
    },
    titles: {
      services: "Servicios",
      links: "Enlaces de interés",
      contact: "Contacto"
    },
    bottom: {
      copyright: "Copyright 2025 Frenkel. Derechos Reservados",
      terms: "Términos y condiciones",
      privacy: "Política de privacidad",
       cookies: "Política de cookies" 
    }
  },
  en: {
    phrase: "Solutions that transform your industry.",
    columns: {
      services: [
        { label: "Industry 4.0", url: "/industria-4-0" },
        { label: "Consulting & Advisory", url: "/consultoria-asesoria-ingenieria" },
        { label: "Control Automation", url: "/automatizacion-de-control" },
        { label: "Process Engineering", url: "/ingenieria-de-proceso" },
        { label: "IT & Software Development", url: "/it-desarrollo-software" }
      ],
      links: [
        { label: "About Us", url: "/nosotros" },
        { label: "Training", url: "/capacitacion" },
        { label: "Success Stories", url: "/casosdeexito" },
        { label: "Blog", url: "/blog" },
        { label: "Contact", url: "/contacto" }
      ],
      contact: {
        phones: ["52 55 3996 0462", "52 33 3900 8533", "52 55 9186 3622"],
        email: "admon@frenkel.com.mx",
        hours: "Customer service: 9:00 to 18:00"
      }
    },
    titles: {
      services: "Services",
      links: "Useful links",
      contact: "Contact"
    },
    bottom: {
      copyright: "Copyright 2025 Frenkel. All Rights Reserved",
      terms: "Terms & Conditions",
      privacy: "Privacy Policy",
      cookies: "Cookie Policy"
    }
  },
  de: {
    phrase: "Lösungen, die Ihre Branche transformieren.",
    columns: {
      services: [
        { label: "Industrie 4.0", url: "/industria-4-0" },
        { label: "Beratung & Consulting", url: "/consultoria-asesoria-ingenieria" },
        { label: "Automatisierungstechnik", url: "/automatizacion-de-control" },
        { label: "Verfahrenstechnik", url: "/ingenieria-de-proceso" },
        { label: "IT & Softwareentwicklung", url: "/it-desarrollo-software" }
      ],
      links: [
        { label: "Über uns", url: "/nosotros" },
        { label: "Schulungen", url: "/capacitacion" },
        { label: "Erfolgsgeschichten", url: "/casosdeexito" },
        { label: "Blog", url: "/blog" },
        { label: "Kontakt", url: "/contacto" }
      ],
      contact: {
        phones: ["52 55 3996 0462", "52 33 3900 8533", "52 55 9186 3622"],
        email: "admon@frenkel.com.mx",
        hours: "Servicezeiten: 9:00 bis 18:00"
      }
    },
    titles: {
      services: "Dienstleistungen",
      links: "Nützliche Links",
      contact: "Kontakt"
    },
    bottom: {
      copyright: "Copyright 2025 Frenkel. Alle Rechte vorbehalten",
      terms: "AGB",
      privacy: "Datenschutz-Bestimmungen",
      cookies: "Cookie-Richtlinie"
    }
  },
  social: [
    {
      name: "facebook",
      url: "https://www.facebook.com/share/15PwNPG8gK/?mibextid=wwXIfr",
      icon: "mdi:facebook"
    },
    {
      name: "instagram",
      url: "https://www.instagram.com/frenkelmx?igsh=MWx6ODh0YzN1bmN5Ng==",
      icon: "mdi:instagram"
    },
    {
      name: "tiktok",
      url: "https://www.tiktok.com/@frenkelmx?_t=ZS-8xI21bxjNiS&_r=1",
      icon: "ic:baseline-tiktok"
    },
    {
      name: "linkedin",
      url: "https://www.linkedin.com/company/frenkel-engineering/",
      icon: "mdi:linkedin"
    }
  ]
};

export const beneficiosSteps = {
  es: [
    {
      title: "¿Qué beneficios puede conseguir?",
      stepTitle: "Maximizar el potencial de mi planta",
      description: `Analizamos la planta en su totalidad para ayudarte a mejorar sus procesos productivos y producto final.
Detectamos en dónde están faltando datos, en qué parte se cortan los flujos de información y cuándo se toman decisiones antes de tener los datos correctos.

Estos datos nos permiten detectar oportunidades e implementar soluciones que resultan en la disminución de mermas e incremento de la productividad tanto de la maquinaria como del personal.`,
      imgAlt: "Placeholder Paso  1",
      imgSrc:new URL('../images/beneficios01.png', import.meta.url).href,
      imgCaption: "No se necesita una inversión enorme, re-utilizamos la tecnología que ya se tiene instalada, incorporando instrumentos de medición para disminuir los costos."
    },
    {
      title: "¿Qué beneficios puede conseguir?",
      stepTitle: "Disponibilidad y acceso a la información",
      description: `Mediante la instalación de sistemas de control recolectamos información de toda la planta y la almacenamos en la nube, lista para ser analizada en el momento oportuno.

A través de software hecho a la medida de tus necesidades puedes acceder a la información que necesitas sobre tu planta en tiempo real desde cualquier lugar con acceso a internet, a través de tu computadora, tableta o smartphone.`,
      imgAlt: "Placeholder step 2",
      imgSrc: new URL('../images/beneficios02.png', import.meta.url).href,
      imgCaption: `Es posible tener “dashboards” predeterminados con información que necesitas de manera recurrente para tomar decisiones.`
    },
    {
      title: "¿Qué beneficios puede conseguir?",
      stepTitle: "Disminución de errores y fallas",
      description: `Al automatizar procesos y tener monitoreo constante de todos los instrumentos de la planta se elimina la posibilidad de errores humanos que van desde un error de dedo en la captura de información, hasta accidentes en campo por descuidos.

De la misma manera, la acumulación de gran cantidad de información (Big Data) en la nube y su análisis en tiempo real nos permite predecir fallas de campo, evitando paradas de producción, a través de mantenimiento predictivo y preventivo.`,
      imgAlt: "Placeholder step 3",
      imgSrc: new URL('../images/beneficios03.png', import.meta.url).href,
      imgCaption: `La inteligencia artificial es un gran aliado en el reconocimiento de patrones imposibles de identificar por un ser humano.`
    },
    {
      title: "¿Qué beneficios puede conseguir?",
      stepTitle: "Mejorar la comunicación de mi empresa",
      description: `Teniendo una base de datos centralizada que recopila información directamente de los aparatos en campo es posible generar y enviar de forma automatizada reportes personalizados a tus clientes y a las áreas involucradas dentro de su empresa, resaltando únicamente la información que le es de utilidad a cada uno.

De esta manera todos tienen la misma información al mismo tiempo, proveniente de instrumentos certificados por los mejores proveedores de hardware del mundo.`,
      imgAlt: "Placeholder step 4",
      imgSrc: new URL('../images/beneficios04.png', import.meta.url).href,
      imgCaption: `Algunas fábricas automotrices ya están estableciendo comunicación incluso con los consumidores finales, sincronizando el pintado de los autos con las compras realizadas en tiempo real.`
    }
  ],
  en: [
    {
      title: "What benefits can you achieve?",
      stepTitle: "Maximize the potential of my plant",
      description: `We analyze the plant as a whole to help you improve its productive processes and final product.
We detect where data is missing, where information flows are cut off, and when decisions are made before having the correct data.

This data allows us to identify opportunities and implement solutions that result in reduced waste and increased productivity of both machinery and personnel.`,
      imgAlt: "Placeholder step 1",
      imgSrc: new URL('../images/beneficios01.png', import.meta.url).href,
      imgCaption: "A huge investment is not required; we reuse the technology already installed, incorporating measurement instruments to reduce costs."
    },
    {
      title: "What benefits can you achieve?",
      stepTitle: "Availability and access to information",
      description: `By installing control systems, we collect information from the entire plant and store it in the cloud, ready to be analyzed at the right time.

With software tailored to your needs, you can access the information you need about your plant in real time from anywhere with internet access, through your computer, tablet, or smartphone.`,
      imgAlt: "Placeholder step 2",
      imgSrc: new URL('../images/beneficios02.png', import.meta.url).href,
      imgCaption: `It is possible to have pre-set dashboards with the information you need regularly to make decisions.`
    },
    {
      title: "What benefits can you achieve?",
      stepTitle: "Reduction of errors and failures",
      description: `By automating processes and constantly monitoring all plant instruments, the possibility of human errors is eliminated—from simple data entry mistakes to field accidents due to oversight.

Likewise, the accumulation of large amounts of information (Big Data) in the cloud and its real-time analysis allows us to predict field failures, avoiding production stoppages, through predictive and preventive maintenance.`,
      imgAlt: "Placeholder step 3",
      imgSrc: new URL('../images/beneficios03.png', import.meta.url).href,
      imgCaption: `Artificial intelligence is a great ally in recognizing patterns that are impossible for a human to identify.`
    },
    {
      title: "What benefits can you achieve?",
      stepTitle: "Improve company communication",
      description: `With a centralized database that collects information directly from field devices, it is possible to generate and automatically send personalized reports to your clients and to the areas involved within your company, highlighting only the information useful for each one.

In this way, everyone has the same information at the same time, coming from instruments certified by the world's best hardware suppliers.`,
      imgAlt: "Placeholder step 4",
      imgSrc: new URL('../images/beneficios04.png', import.meta.url).href,
      imgCaption: `Some automotive factories are already establishing communication even with end consumers, synchronizing the painting of cars with purchases made in real time.`
    }
  ],
  de: [
    {
      title: "Welche Vorteile können Sie erzielen?",
      stepTitle: "Das Potenzial meiner Anlage maximieren",
      description: `Wir analysieren die Anlage als Ganzes, um Ihnen zu helfen, die Produktionsprozesse und das Endprodukt zu verbessern.
Wir erkennen, wo Daten fehlen, wo Informationsflüsse unterbrochen werden und wann Entscheidungen getroffen werden, bevor die richtigen Daten vorliegen.

Diese Daten ermöglichen es uns, Chancen zu erkennen und Lösungen umzusetzen, die zu weniger Ausschuss und höherer Produktivität von Maschinen und Personal führen.`,
      imgAlt: "Platzhalter Schritt 1",
      imgSrc: new URL('../images/beneficios01.png', import.meta.url).href,
      imgCaption: "Eine riesige Investition ist nicht nötig. Wir nutzen die bereits installierte Technologie weiter und integrieren Messinstrumente zur Kostensenkung."
    },
    {
      title: "Welche Vorteile können Sie erzielen?",
      stepTitle: "Verfügbarkeit und Zugang zu Informationen",
      description: `Durch die Installation von Kontrollsystemen sammeln wir Informationen aus der gesamten Anlage und speichern sie in der Cloud, damit sie zum richtigen Zeitpunkt analysiert werden können.

Mit Software, die auf Ihre Bedürfnisse zugeschnitten ist, können Sie von überall mit Internetzugang in Echtzeit auf die Informationen Ihrer Anlage zugreifen – über Ihren Computer, Ihr Tablet oder Smartphone.`,
      imgAlt: "Platzhalter Schritt 2",
      imgSrc: new URL('../images/beneficios02.png', import.meta.url).href,
      imgCaption: `Es ist möglich, vordefinierte Dashboards mit regelmäßig benötigten Informationen zur Entscheidungsfindung zu haben.`
    },
    {
      title: "Welche Vorteile können Sie erzielen?",
      stepTitle: "Reduzierung von Fehlern und Ausfällen",
      description: `Durch die Automatisierung von Prozessen und die ständige Überwachung aller Instrumente der Anlage wird die Möglichkeit menschlicher Fehler – vom Tippfehler bei der Datenerfassung bis zu Unfällen vor Ort durch Nachlässigkeit – beseitigt.

Ebenso ermöglicht die Ansammlung großer Datenmengen (Big Data) in der Cloud und deren Echtzeitanalyse die Vorhersage von Feldausfällen und das Vermeiden von Produktionsstopps durch vorausschauende und vorbeugende Wartung.`,
      imgAlt: "Platzhalter Schritt 3",
      imgSrc: new URL('../images/beneficios03.png', import.meta.url).href,
      imgCaption: `Künstliche Intelligenz ist ein großer Verbündeter bei der Erkennung von Mustern, die für den Menschen unmöglich zu erkennen sind.`
    },
    {
      title: "Welche Vorteile können Sie erzielen?",
      stepTitle: "Die Kommunikation im Unternehmen verbessern",
      description: `Mit einer zentralisierten Datenbank, die Informationen direkt von den Geräten im Feld sammelt, können automatisiert personalisierte Berichte für Ihre Kunden und die beteiligten Bereiche im Unternehmen erstellt und versendet werden, wobei jeweils nur die für den Empfänger nützlichen Informationen hervorgehoben werden.

So haben alle gleichzeitig dieselben Informationen, bereitgestellt von den besten Hardwareanbietern weltweit zertifizierter Instrumente.`,
      imgAlt: "Platzhalter Schritt 4",
      imgSrc: new URL('../images/beneficios04.png', import.meta.url).href,
      imgCaption: `Einige Automobilhersteller stellen bereits die Kommunikation mit Endkunden her und synchronisieren das Lackieren der Fahrzeuge mit den in Echtzeit getätigten Käufen.`
    }
  ]
};

export const cookiesPolicy = {
  es: {
    title: "Políticas de cookies",
    intro: `En [Nombre de la empresa] (en adelante "Frenkel"), utilizamos cookies para mejorar la experiencia de nuestros usuarios en nuestro sitio web. Esta política explica qué son las cookies y cómo las usamos.`,
    whatAreCookiesTitle: "¿Qué son las cookies?",
    whatAreCookies: `Las cookies son pequeños archivos de texto que se almacenan en su dispositivo cuando visita nuestro sitio web. Estas cookies nos permiten reconocer su dispositivo y personalizar su experiencia en el sitio.`,
    typesTitle: "Tipos de Cookies que Usamos",
    typesList: [
      "Cookies Esenciales: Son necesarias para el funcionamiento del sitio web y no se pueden desactivar.",
      "Cookies de Rendimiento: Recopilan información sobre cómo los usuarios interactúan con el sitio web.",
      "Cookies Funcionales: Permiten que el sitio recuerde las opciones que usted selecciona.",
      "Cookies de Publicidad: Utilizadas para personalizar los anuncios según sus intereses.",
    ],
    controlTitle: "Cómo Controlar las Cookies",
    controlText: `Puede configurar su navegador para que bloquee las cookies o le avise cuando se envíen. Sin embargo, esto puede afectar la funcionalidad de algunos servicios en el sitio web de Frenkel.`,
    changesTitle: "Modificaciones",
    changesText: `Frenkel se reserva el derecho de actualizar esta política de cookies en cualquier momento. Cualquier cambio será publicado en nuestro sitio web.`
  },
  en: {
    title: "Cookie Policy",
    intro: `At [Company Name] (“Frenkel”), we use cookies to improve the experience of our users on our website. This policy explains what cookies are and how we use them.`,
    whatAreCookiesTitle: "What are cookies?",
    whatAreCookies: `Cookies are small text files stored on your device when you visit our website. These cookies allow us to recognize your device and personalize your experience on the site.`,
    typesTitle: "Types of Cookies We Use",
    typesList: [
      "Essential Cookies: Necessary for the website to function and cannot be disabled.",
      "Performance Cookies: Collect information about how users interact with the website.",
      "Functional Cookies: Allow the site to remember the choices you make.",
      "Advertising Cookies: Used to personalize ads based on your interests.",
    ],
    controlTitle: "How to Control Cookies",
    controlText: `You can set your browser to block cookies or alert you when cookies are sent. However, this may affect the functionality of some services on the Frenkel website.`,
    changesTitle: "Modifications",
    changesText: `Frenkel reserves the right to update this cookie policy at any time. Any changes will be published on our website.`
  },
  de: {
    title: "Cookie-Richtlinie",
    intro: `Bei [Name des Unternehmens] (im Folgenden "Frenkel") verwenden wir Cookies, um die Benutzererfahrung auf unserer Website zu verbessern. Diese Richtlinie erklärt, was Cookies sind und wie wir sie verwenden.`,
    whatAreCookiesTitle: "Was sind Cookies?",
    whatAreCookies: `Cookies sind kleine Textdateien, die auf Ihrem Gerät gespeichert werden, wenn Sie unsere Website besuchen. Diese Cookies ermöglichen es uns, Ihr Gerät zu erkennen und Ihr Erlebnis auf der Website zu personalisieren.`,
    typesTitle: "Arten von Cookies, die wir verwenden",
    typesList: [
      "Essenzielle Cookies: Erforderlich für den Betrieb der Website und können nicht deaktiviert werden.",
      "Leistungs-Cookies: Sammeln Informationen darüber, wie Nutzer mit der Website interagieren.",
      "Funktionale Cookies: Ermöglichen es der Website, sich an Ihre getroffenen Auswahlmöglichkeiten zu erinnern.",
      "Werbe-Cookies: Werden verwendet, um Anzeigen basierend auf Ihren Interessen zu personalisieren.",
    ],
    controlTitle: "So steuern Sie Cookies",
    controlText: `Sie können Ihren Browser so einstellen, dass Cookies blockiert werden oder Sie benachrichtigt werden, wenn Cookies gesendet werden. Dies kann jedoch die Funktionalität einiger Dienste auf der Frenkel-Website beeinträchtigen.`,
    changesTitle: "Änderungen",
    changesText: `Frenkel behält sich das Recht vor, diese Cookie-Richtlinie jederzeit zu aktualisieren. Änderungen werden auf unserer Website veröffentlicht.`
  }
};

export const privacidadContent = {
  es: {
    title: "Aviso de privacidad",
    intro: `En Automation and Cloud Industrial Solutions (en adelante "Frenkel"), respetamos y protegemos la privacidad de nuestros usuarios. Este aviso de privacidad tiene como objetivo informarle sobre cómo recopilamos, utilizamos y protegemos sus datos personales.`,
    sections: [
      {
        heading: "Datos Recopilados",
        text: `Recopilamos información personal, como nombre, dirección de correo electrónico, número de teléfono, dirección IP, entre otros, que usted nos proporciona voluntariamente al interactuar con nuestros servicios, ya sea al registrarse en nuestro sitio web, realizar compras o contactarnos a través de nuestros canales de atención.`
      },
      {
        heading: "Uso de los Datos",
        text: `Los datos recopilados serán utilizados para:

- Gestionar su cuenta y las transacciones relacionadas.
- Mejorar nuestros productos y servicios.
- Enviarle comunicaciones relacionadas con nuestros servicios, ofertas o actualizaciones.
- Cumplir con nuestras obligaciones legales y contractuales.
`
      },
      {
        heading: "Protección de Datos",
        text: `Implementamos medidas de seguridad adecuadas para proteger la información personal de nuestros usuarios. Sin embargo, ninguna transmisión de datos a través de internet puede garantizarse como completamente segura, por lo que no podemos asegurar la protección absoluta de la información.`
      },
      {
        heading: "Derechos de los Usuarios",
        text: `Usted tiene el derecho de acceder, rectificar, cancelar o oponerse al uso de sus datos personales. Puede ejercer estos derechos a través de nuestro servicio de atención al cliente.`
      }
    ]
  },
  en: {
    title: "Privacy Notice",
    intro: `At Automation and Cloud Industrial Solutions ("Frenkel"), we respect and protect our users' privacy. This privacy notice aims to inform you about how we collect, use, and protect your personal data.`,
    sections: [
      {
        heading: "Collected Data",
        text: `We collect personal information such as name, email address, phone number, IP address, among others, that you provide voluntarily when interacting with our services, whether registering on our website, making purchases, or contacting us through our customer service channels.`
      },
      {
        heading: "Use of Data",
        text: `The collected data will be used to:

- Manage your account and related transactions.
- Improve our products and services.
- Send you communications related to our services, offers, or updates.
- Fulfill our legal and contractual obligations.
`
      },
      {
        heading: "Data Protection",
        text: `We implement appropriate security measures to protect users' personal information. However, no data transmission over the internet can be guaranteed as completely secure, so we cannot ensure absolute protection of the information.`
      },
      {
        heading: "User Rights",
        text: `You have the right to access, rectify, cancel, or oppose the use of your personal data. You may exercise these rights through our customer service.`
      }
    ]
  },
  de: {
    title: "Datenschutzhinweis",
    intro: `Bei Automation and Cloud Industrial Solutions („Frenkel“) respektieren und schützen wir die Privatsphäre unserer Nutzer. Dieser Datenschutzhinweis soll Sie darüber informieren, wie wir Ihre personenbezogenen Daten erfassen, verwenden und schützen.`,
    sections: [
      {
        heading: "Erhobene Daten",
        text: `Wir erfassen personenbezogene Informationen wie Name, E-Mail-Adresse, Telefonnummer, IP-Adresse und andere, die Sie uns freiwillig beim Interagieren mit unseren Diensten, bei der Registrierung auf unserer Website, beim Einkaufen oder beim Kontakt mit unserem Kundenservice zur Verfügung stellen.`
      },
      {
        heading: "Verwendung der Daten",
        text: `Die erhobenen Daten werden verwendet, um:

- Ihr Konto und die damit verbundenen Transaktionen zu verwalten.
- Unsere Produkte und Dienstleistungen zu verbessern.
- Ihnen Mitteilungen zu unseren Dienstleistungen, Angeboten oder Aktualisierungen zu senden.
- Unsere gesetzlichen und vertraglichen Verpflichtungen zu erfüllen.
`
      },
      {
        heading: "Datenschutz",
        text: `Wir setzen geeignete Sicherheitsmaßnahmen ein, um die persönlichen Daten unserer Nutzer zu schützen. Dennoch kann keine Datenübertragung über das Internet als vollkommen sicher garantiert werden, sodass wir keinen absoluten Schutz der Informationen gewährleisten können.`
      },
      {
        heading: "Rechte der Nutzer",
        text: `Sie haben das Recht, auf Ihre personenbezogenen Daten zuzugreifen, sie zu berichtigen, zu löschen oder der Nutzung zu widersprechen. Diese Rechte können Sie über unseren Kundenservice ausüben.`
      }
    ]
  }
};


export const terminosContent = {
  es: {
    title: "Términos y condiciones",
    intro: `Estos términos y condiciones (en adelante "Términos") rigen el acceso y uso de los servicios proporcionados por [Nombre de la empresa] (en adelante "Frenkel"). Al acceder o utilizar nuestros servicios, usted acepta estos Términos.`,
    sections: [
      {
        heading: "Uso de los Servicios",
        text: `Usted se compromete a utilizar los servicios de Frenkel de acuerdo con la ley aplicable, sin infringir los derechos de propiedad intelectual o de privacidad de terceros. Además, se compromete a no utilizar los servicios para actividades ilegales o fraudulentas.`
      },
      {
        heading: "Propiedad Intelectual",
        text: `Todos los derechos de propiedad intelectual sobre los contenidos disponibles en el sitio web de Frenkel, incluidos textos, imágenes, logos y software, son propiedad de Frenkel o de sus licenciantes.`
      },
      {
        heading: "Modificaciones a los Servicios",
        text: `Frenkel se reserva el derecho de modificar, suspender o descontinuar los servicios en cualquier momento y sin previo aviso.`
      },
      {
        heading: "Limitación de Responsabilidad",
        text: `Frenkel no será responsable por daños directos, indirectos, incidentales o consecuentes derivados del uso de nuestros servicios. El uso de los servicios es bajo su propio riesgo.`
      }
    ]
  },
  en: {
    title: "Terms and Conditions",
    intro: `These terms and conditions (“Terms”) govern access to and use of services provided by [Company Name] (“Frenkel”). By accessing or using our services, you agree to these Terms.`,
    sections: [
      {
        heading: "Use of Services",
        text: `You agree to use Frenkel's services in accordance with applicable law, without infringing on intellectual property rights or privacy rights of others. You also agree not to use the services for illegal or fraudulent activities.`
      },
      {
        heading: "Intellectual Property",
        text: `All intellectual property rights to the content available on Frenkel’s website, including texts, images, logos, and software, belong to Frenkel or its licensors.`
      },
      {
        heading: "Changes to Services",
        text: `Frenkel reserves the right to modify, suspend, or discontinue services at any time and without prior notice.`
      },
      {
        heading: "Limitation of Liability",
        text: `Frenkel is not liable for any direct, indirect, incidental, or consequential damages arising from the use of our services. Use of the services is at your own risk.`
      }
    ]
  },
  de: {
    title: "Allgemeine Geschäftsbedingungen",
    intro: `Diese Allgemeinen Geschäftsbedingungen (“Bedingungen”) regeln den Zugang zu und die Nutzung der von [Firmenname] (“Frenkel”) bereitgestellten Dienstleistungen. Durch den Zugriff auf unsere Dienste oder deren Nutzung akzeptieren Sie diese Bedingungen.`,
    sections: [
      {
        heading: "Nutzung der Dienstleistungen",
        text: `Sie verpflichten sich, die Dienste von Frenkel gemäß geltendem Recht zu nutzen, ohne die Rechte am geistigen Eigentum oder die Datenschutzrechte Dritter zu verletzen. Sie verpflichten sich außerdem, die Dienste nicht für illegale oder betrügerische Aktivitäten zu nutzen.`
      },
      {
        heading: "Geistiges Eigentum",
        text: `Alle Rechte an geistigem Eigentum an den auf der Frenkel-Website verfügbaren Inhalten, einschließlich Texte, Bilder, Logos und Software, liegen bei Frenkel oder seinen Lizenzgebern.`
      },
      {
        heading: "Änderungen an den Dienstleistungen",
        text: `Frenkel behält sich das Recht vor, die Dienstleistungen jederzeit und ohne vorherige Ankündigung zu ändern, auszusetzen oder einzustellen.`
      },
      {
        heading: "Haftungsbeschränkung",
        text: `Frenkel haftet nicht für direkte, indirekte, zufällige oder Folgeschäden, die sich aus der Nutzung unserer Dienste ergeben. Die Nutzung der Dienste erfolgt auf eigenes Risiko.`
      }
    ]
  }
};

export const contactoContent = {
  es: {
    title: "Hablemos",
    description: `De la idea a la operación, sin fricciones.
Contáctanos hoy y descubre cómo integrar automatización, IIoT y análisis de datos en tu proceso.
`,
    form: {
      name: "Nombre completo*",
      email: "Correo*",
      company: "Compañía*",
      subject: "Asunto*",
      message: "Mensaje*",
      send: "Enviar",
      subjectPlaceholder: "Selecciona un asunto",
      subjectOptions: [
        "Cotización", "Soporte", "Comentario", "Otro"
      ]
    }
  },
  en: {
    title: "Let's talk",
    description: `From idea to operation—frictionless.
Contact us today and discover how to integrate automation, IIoT, and data analytics into your process.`,
    form: {
      name: "Full name*",
      email: "Email*",
      company: "Company*",
      subject: "Subject*",
      message: "Message*",
      send: "Send",
      subjectPlaceholder: "Select a subject",
      subjectOptions: [
        "Quote", "Support", "Consulting", "Other"
      ]
    }
  },
  de: {
    title: "Sprechen wir",
    description: `Von der Idee bis zum Betrieb – reibungslos.
Kontaktieren Sie uns noch heute und erfahren Sie, wie Sie Automatisierung, IIoT und Datenanalyse in Ihren Prozess integrieren.`,
    form: {
      name: "Vollständiger Name*",
      email: "E-Mail*",
      company: "Firma*",
      subject: "Betreff*",
      message: "Nachricht*",
      send: "Senden",
      subjectPlaceholder: "Betreff auswählen",
      subjectOptions: [
        "Angebot", "Support", "Beratung", "Sonstiges"
      ]
    }
  }
};
export const faqsContent = {
  es: [
    {
      question: "¿Quién es Frenkel y qué experiencia tiene en la industria?",
      answer: `Frenkel es una empresa especializada en automatización industrial, IIoT e Industria 4.0, con más de 15 años de experiencia en proyectos de alto impacto para sectores como alimentos y bebidas, energía y manufactura. Nuestro equipo combina ingeniería, ciencia de datos y programación para ofrecer soluciones robustas y escalables.`
    },
    {
      question: "¿En qué industrias trabaja Frenkel?",
      answer: `Hemos desarrollado proyectos para cervecerías, plantas de alimentos, industrias químicas, energéticas y manufactureras. Nuestra fortaleza es adaptarnos a procesos complejos, integrando tecnología de vanguardia sin interrumpir la operación.`
    },
    {
      question: "¿Qué es IIoT y cómo lo implementa Frenkel?",
      answer: `El IIoT (Internet Industrial de las Cosas) conecta sensores, equipos y sistemas industriales para recolectar y analizar datos en tiempo real. En Frenkel lo implementamos con arquitecturas modulares, comunicaciones seguras y protocolos estándar como OPC UA y MQTT.`
    },
    {
      question: "¿Se pueden integrar sus soluciones con sistemas y PLCs existentes?",
      answer: `Sí. Diseñamos nuestras soluciones para integrarse de forma no invasiva con los sistemas actuales, sean Siemens, Rockwell u otras marcas, evitando costosas migraciones.`
    },
    {
      question: "¿Qué tecnologías utilizan para digitalizar procesos?",
      answer: `Usamos PLCs y edge devices de última generación, plataformas SCADA y MES, visión artificial, análisis avanzado de datos y conectividad IIoT. Adaptamos la tecnología a la necesidad, no al revés.`
    },
    {
      question: "¿Cómo es el proceso de trabajo de Frenkel?",
      answer: `Iniciamos con un levantamiento técnico en planta, definimos el alcance y proponemos una arquitectura. Después desarrollamos, probamos y ponemos en marcha la solución, garantizando capacitación y soporte post-implementación.`
    },
    {
      question: "¿Pueden desarrollar soluciones a la medida?",
      answer: `Sí. Cada proyecto se diseña para responder a los objetivos del cliente, considerando escalabilidad, flexibilidad y compatibilidad con el proceso actual.`
    },
    {
      question: "¿Ofrecen soluciones modulares y escalables?",
      answer: `Siempre. Nuestras arquitecturas permiten comenzar con un piloto y ampliar la cobertura de manera progresiva, optimizando la inversión.`
    },
    {
      question: "¿Ofrecen soporte remoto y presencial?",
      answer: `Sí. Contamos con soporte remoto para resolución rápida de incidencias y asistencia presencial para mantenimiento preventivo, correctivo y actualizaciones de sistemas.`
    },
    {
      question: "¿Cuáles son sus tiempos de respuesta?",
      answer: `Dependen del tipo de contrato y la criticidad del equipo. En casos urgentes, brindamos atención remota inmediata y desplazamiento a planta en menos de 24 horas.`
    },
    {
      question: "¿Proveen capacitación al personal del cliente?",
      answer: `Sí. Impartimos cursos técnicos adaptados a distintos perfiles: operadores, técnicos de mantenimiento e ingenieros de automatización.`
    },
    {
      question: "¿Tienen experiencia con proyectos de alta complejidad?",
      answer: `Sí. Por ejemplo, participamos en la puesta en marcha de la Cervecería Modelo de Apan —récord mundial por su velocidad de arranque— integrando sistemas Siemens y Braumat.`
    },
    {
      question: "¿Pueden dar ejemplos de beneficios logrados?",
      answer: `Hemos reducido fallos de maquinaria en más de un 40% mediante mantenimiento predictivo, optimizado consumos de energía y agua con monitoreo en tiempo real, y mejorado la trazabilidad de producción.`
    },
    {
      question: "¿Cómo garantizan la seguridad de los datos?",
      answer: `Aplicamos ciberseguridad industrial desde el diseño, con segmentación de redes, cifrado de datos y autenticación segura para usuarios y dispositivos.`
    },
    {
      question: "¿Qué pasa si mi proceso cambia en el futuro?",
      answer: `Nuestras soluciones están diseñadas para adaptarse a cambios de producción, nuevas líneas o expansiones, protegiendo la inversión a largo plazo.`
    }
  ],
  en: [
    {
      question: "Who is Frenkel and what experience do you have in the industry?",
      answer: `Frenkel is a company specialized in industrial automation, IIoT, and Industry 4.0, with 15+ years of experience delivering high-impact projects for food & beverage, energy, and manufacturing. Our team blends engineering, data science, and software to provide robust, scalable solutions.`
    },
    {
      question: "Which industries does Frenkel work in?",
      answer: `We have delivered projects for breweries, food plants, chemical, energy, and manufacturing companies. Our strength is adapting to complex processes and integrating cutting-edge technology without disrupting operations.`
    },
    {
      question: "What is IIoT and how does Frenkel implement it?",
      answer: `IIoT (Industrial Internet of Things) connects sensors, equipment, and industrial systems to collect and analyze real-time data. We implement it using modular architectures, secure communications, and standards such as OPC UA and MQTT.`
    },
    {
      question: "Can your solutions integrate with existing systems and PLCs?",
      answer: `Yes. Our solutions are designed to integrate non-invasively with current systems—Siemens, Rockwell, and others—avoiding costly migrations.`
    },
    {
      question: "What technologies do you use to digitize processes?",
      answer: `We use next-gen PLCs and edge devices, SCADA and MES platforms, computer vision, advanced analytics, and IIoT connectivity. We fit the technology to the need—not the other way around.`
    },
    {
      question: "What is Frenkel’s project delivery process?",
      answer: `We start with an on-site technical assessment, define scope, and propose an architecture. Then we develop, test, and commission the solution, ensuring training and post-implementation support.`
    },
    {
      question: "Do you build custom solutions?",
      answer: `Yes. Every project is designed around the client’s objectives, considering scalability, flexibility, and compatibility with the current process.`
    },
    {
      question: "Do you offer modular and scalable solutions?",
      answer: `Always. Our architectures let you start with a pilot and expand coverage progressively, optimizing investment.`
    },
    {
      question: "Do you provide remote and on-site support?",
      answer: `Yes. We offer remote support for quick issue resolution and on-site assistance for preventive/corrective maintenance and system upgrades.`
    },
    {
      question: "What are your response times?",
      answer: `They depend on the contract type and equipment criticality. For urgent cases, we provide immediate remote attention and can travel on-site in under 24 hours.`
    },
    {
      question: "Do you train our staff?",
      answer: `Yes. We deliver technical courses tailored to operators, maintenance technicians, and automation engineers.`
    },
    {
      question: "Do you have experience with highly complex projects?",
      answer: `Yes. For example, we helped commission Cervecería Modelo de Apan—a world record for startup speed—integrating Siemens and Braumat systems.`
    },
    {
      question: "Can you share examples of achieved benefits?",
      answer: `We have reduced machine failures by over 40% through predictive maintenance, optimized energy and water consumption with real-time monitoring, and improved production traceability.`
    },
    {
      question: "How do you ensure data security?",
      answer: `We apply industrial cybersecurity by design: network segmentation, data encryption, and secure user/device authentication.`
    },
    {
      question: "What if my process changes in the future?",
      answer: `Our solutions are designed to adapt to production changes, new lines, or expansions—protecting your long-term investment.`
    }
  ],
  de: [
    {
      question: "Wer ist Frenkel und welche Erfahrung haben Sie in der Industrie?",
      answer: `Frenkel ist auf Industrieautomatisierung, IIoT und Industrie 4.0 spezialisiert und verfügt über mehr als 15 Jahre Erfahrung mit wirkungsstarken Projekten in den Bereichen Lebensmittel & Getränke, Energie und Fertigung. Unser Team vereint Ingenieurwesen, Data Science und Softwareentwicklung für robuste, skalierbare Lösungen.`
    },
    {
      question: "In welchen Branchen ist Frenkel tätig?",
      answer: `Wir haben Projekte für Brauereien, Lebensmittelwerke sowie Chemie-, Energie- und Produktionsunternehmen umgesetzt. Unsere Stärke ist die Anpassung an komplexe Prozesse und die Integration modernster Technologien ohne Betriebsunterbrechung.`
    },
    {
      question: "Was ist IIoT und wie setzt Frenkel es um?",
      answer: `IIoT (Industrial Internet of Things) verbindet Sensoren, Anlagen und Systeme, um Daten in Echtzeit zu erfassen und zu analysieren. Wir realisieren dies mit modularen Architekturen, sicheren Kommunikationswegen und Standards wie OPC UA und MQTT.`
    },
    {
      question: "Lassen sich Ihre Lösungen in bestehende Systeme und SPS integrieren?",
      answer: `Ja. Unsere Lösungen integrieren sich nicht-invasiv in vorhandene Systeme—Siemens, Rockwell u. a.—und vermeiden kostspielige Migrationen.`
    },
    {
      question: "Welche Technologien nutzen Sie zur Digitalisierung von Prozessen?",
      answer: `Wir setzen moderne SPS und Edge-Devices, SCADA- und MES-Plattformen, Computer Vision, fortgeschrittene Datenanalytik und IIoT-Konnektivität ein. Die Technologie wird der Anforderung angepasst, nicht umgekehrt.`
    },
    {
      question: "Wie läuft der Projektprozess bei Frenkel ab?",
      answer: `Wir beginnen mit einer technischen Aufnahme vor Ort, definieren den Umfang und schlagen eine Architektur vor. Anschließend entwickeln, testen und nehmen wir die Lösung in Betrieb—inklusive Schulung und Support nach der Implementierung.`
    },
    {
      question: "Entwickeln Sie maßgeschneiderte Lösungen?",
      answer: `Ja. Jedes Projekt wird auf die Ziele des Kunden zugeschnitten—unter Berücksichtigung von Skalierbarkeit, Flexibilität und Kompatibilität mit dem bestehenden Prozess.`
    },
    {
      question: "Bieten Sie modulare und skalierbare Lösungen an?",
      answer: `Immer. Unsere Architekturen ermöglichen einen Pilotstart und eine schrittweise Erweiterung—für eine optimale Investition.`
    },
    {
      question: "Bieten Sie Remote- und Vor-Ort-Support?",
      answer: `Ja. Wir leisten Remote-Support zur schnellen Störungsbehebung und Vor-Ort-Einsätze für präventive/korrektive Wartung sowie System-Upgrades.`
    },
    {
      question: "Wie schnell reagieren Sie?",
      answer: `Die Zeiten hängen von Vertrag und Kritikalität der Anlage ab. In dringenden Fällen leisten wir sofortigen Remote-Support und sind innerhalb von weniger als 24 Stunden vor Ort.`
    },
    {
      question: "Schulen Sie das Personal des Kunden?",
      answer: `Ja. Wir bieten technische Schulungen für Bediener, Instandhaltungstechniker und Automatisierungsingenieure.`
    },
    {
      question: "Haben Sie Erfahrung mit hochkomplexen Projekten?",
      answer: `Ja. Beispielsweise waren wir an der Inbetriebnahme der Cervecería Modelo de Apan beteiligt—ein Weltrekord in Anfahrgeschwindigkeit—unter Integration von Siemens- und Braumat-Systemen.`
    },
    {
      question: "Können Sie erzielte Vorteile nennen?",
      answer: `Wir haben Maschinenstillstände durch Predictive Maintenance um über 40 % reduziert, Energie- und Wasserverbräuche per Echtzeit-Monitoring optimiert und die Produktionstransparenz verbessert.`
    },
    {
      question: "Wie stellen Sie die Datensicherheit sicher?",
      answer: `Wir berücksichtigen Industrial Cybersecurity von Anfang an: Netzsegmentierung, Datenverschlüsselung und sichere Authentifizierung für Nutzer und Geräte.`
    },
    {
      question: "Was passiert, wenn sich mein Prozess künftig ändert?",
      answer: `Unsere Lösungen sind darauf ausgelegt, sich an Produktionsänderungen, neue Linien oder Erweiterungen anzupassen—und so die Investition langfristig zu schützen.`
    }
  ]
};

export const error404Content = {
  es: {
    image:  new URL('../images/error.png', import.meta.url).href,
    error: '404 ERROR',
    oops: '¡Oops! Página no encontrada.',
    description: 'Lamentablemente, no pudimos encontrar la página que estás buscando. Puede que el enlace esté roto, o la página haya sido eliminada o movida a otro lugar.',
    whatDo: '¿Qué puedes hacer?',
    bullets: [
      '<a href="/">Volver a la página de inicio</a> y explorar nuestros servicios.',
      'Si necesitas ayuda, contacta con nuestro <a href="mailto:correo@frenkel.com">soporte</a>.'
    ],
    sorry: 'Lamentamos cualquier inconveniente.'
  },
  en: {
    image: 'https://franklinbelen.com/wp-content/uploads/cual-es-el-error-404-not-fund.jpg',
    error: '404 ERROR',
    oops: 'Oops! Page not found.',
    description: 'Unfortunately, we could not find the page you are looking for. The link may be broken, or the page may have been removed or moved elsewhere.',
    whatDo: 'What can you do?',
    bullets: [
      '<a href="/">Return to the homepage</a> and explore our services.',
      'If you need help, contact our <a href="mailto:correo@frenkel.com">support</a>.'
    ],
    sorry: 'We apologize for any inconvenience.'
  },
  de: {
    image: 'https://franklinbelen.com/wp-content/uploads/cual-es-el-error-404-not-fund.jpg',
    error: '404 FEHLER',
    oops: 'Hoppla! Seite nicht gefunden.',
    description: 'Leider konnten wir die gesuchte Seite nicht finden. Der Link ist möglicherweise defekt oder die Seite wurde entfernt oder verschoben.',
    whatDo: 'Was können Sie tun?',
    bullets: [
      '<a href="/">Zur Startseite zurückkehren</a> und unsere Dienstleistungen erkunden.',
      'Wenn Sie Hilfe benötigen, kontaktieren Sie unseren <a href="mailto:correo@frenkel.com">Support</a>.'
    ],
    sorry: 'Wir entschuldigen uns für die Unannehmlichkeiten.'
  }
}


export const historiaFrenkel = {
  title: {
    es: "Historia de Frenkel",
    en: "Frenkel's Story",
    de: "Frenkels Geschichte"
  },
  content: {
    es: `
Frenkel nació en 2020 como resultado de la visión conjunta de Alicia Alejandra Ramírez Mata y Luis Enrique Solís Díaz, quienes decidieron unir su experiencia técnica y estratégica para transformar la industria mexicana mediante soluciones de automatización, digitalización e inteligencia artificial.

Desde sus inicios, Frenkel se ha dedicado a integrar tecnologías disruptivas como el Internet Industrial de las Cosas (IIoT), computación en la nube, machine learning e inteligencia artificial, para optimizar procesos industriales y mercantiles de forma escalable, segura y eficiente. Con un enfoque práctico y altamente especializado, la empresa ha liderado proyectos tanto en México como en el extranjero, destacándose en sectores como el alimentos y bebidas, química, farmacéutica, manufactura avanzada, entre otros.

Con un equipo multidisciplinario y comprometido, Frenkel ha logrado posicionarse como un referente nacional en Industria 4.0, destacando no solo por su capacidad técnica, sino por su enfoque humano y su compromiso con la excelencia operativa.
    `,
    en: `
Frenkel was founded in 2020 as the result of the shared vision of Alicia Alejandra Ramírez Mata and Luis Enrique Solís Díaz, who decided to combine their technical and strategic expertise to transform the Mexican industry through automation, digitalization, and artificial intelligence solutions.

Since its inception, Frenkel has focused on integrating disruptive technologies such as Industrial Internet of Things (IIoT), cloud computing, machine learning, and artificial intelligence to optimize industrial and commercial processes in a scalable, secure, and efficient way. With a practical and highly specialized approach, the company has led projects both in Mexico and abroad, standing out in sectors such as food and beverage, chemical, pharmaceutical, advanced manufacturing, among others.

With a multidisciplinary and committed team, Frenkel has positioned itself as a national benchmark in Industry 4.0, standing out not only for its technical capacity but also for its human approach and commitment to operational excellence.
    `,
    de: `
Frenkel wurde 2020 als Ergebnis der gemeinsamen Vision von Alicia Alejandra Ramírez Mata und Luis Enrique Solís Díaz gegründet, die beschlossen, ihre technische und strategische Erfahrung zu bündeln, um die mexikanische Industrie durch Automatisierungs-, Digitalisierungs- und KI-Lösungen zu transformieren.

Von Anfang an hat sich Frenkel darauf spezialisiert, disruptive Technologien wie das industrielle Internet der Dinge (IIoT), Cloud-Computing, maschinelles Lernen und künstliche Intelligenz zu integrieren, um industrielle und kommerzielle Prozesse skalierbar, sicher und effizient zu optimieren. Mit einem praxisnahen und hochspezialisierten Ansatz hat das Unternehmen Projekte sowohl in Mexiko als auch im Ausland geleitet und sich in Sektoren wie Lebensmittel und Getränke, Chemie, Pharma, fortschrittliche Fertigung und anderen hervorgetan.

Mit einem multidisziplinären und engagierten Team hat sich Frenkel als nationale Referenz für Industrie 4.0 etabliert, zeichnet sich nicht nur durch technische Kompetenz, sondern auch durch einen menschlichen Ansatz und Engagement für operative Exzellenz aus.
    `
  }
};


export const metodoFrenkel = {
  es: {
    title: "Si pudieras saber cualquier cosa sobre tu planta ¿Cuál sería?",
    subtitle: "El método para transformar",
    steps: [
      {
        title: "1. Evaluación Inicial",
        content:
          "Realizamos un análisis detallado de las necesidades de digitalización de tu planta...",
        image:new URL('../images/metodo01.png', import.meta.url).href
      },
      {
        title: "2. Planificación Estratégica",
        content:
          "Definimos objetivos claros y creamos un plan de acción adaptado...",
        image:new URL('../images/metodo02.png', import.meta.url).href
      },
      {
        title: "3. Selección Tecnológica",
        content:
          "Elegimos las mejores herramientas y plataformas tecnológicas...",
        image: new URL('../images/metodo03.png', import.meta.url).href
      },
      {
        title: "4. Aplicación",
        content:
          "Implementamos las tecnologías seleccionadas, integrándolas...",
        image: new URL('../images/metodo04.png', import.meta.url).href
      },
      {
        title: "5. Capacitación",
        content:
          "Formamos a tu equipo para que pueda utilizar las nuevas herramientas...",
        image: new URL('../images/metodo05.png', import.meta.url).href
      },
      {
        title: "6. Monitoreo y Optimización",
        content:
          "Monitoreamos los resultados en tiempo real y realizamos ajustes...",
        image:  new URL('../images/metodo06.png', import.meta.url).href
      }
    ]
  },
  en: {
    title: "If you could know anything about your plant, what would it be?",
    subtitle: "The method to transform",
    steps: [
      {
        title: "1. Initial Assessment",
        content:
          "We conduct a detailed analysis of your plant's digitalization needs...",
        image:  new URL('../images/metodo01.png', import.meta.url).href
      },
      {
        title: "2. Strategic Planning",
        content:
          "We define clear objectives and create an action plan...",
        image:  new URL('../images/metodo02.png', import.meta.url).href
      },
      {
        title: "3. Technology Selection",
        content:
          "We choose the best tools and technology platforms...",
        image: new URL('../images/metodo03.png', import.meta.url).href
      },
      {
        title: "4. Implementation",
        content:
          "We implement the selected technologies...",
        image: new URL('../images/metodo04.png', import.meta.url).href
      },
      {
        title: "5. Training",
        content:
          "We train your team to use the new tools effectively...",
        image:  new URL('../images/metodo05.png', import.meta.url).href
      },
      {
        title: "6. Monitoring and Optimization",
        content:
          "We monitor results in real time and make adjustments...",
        image:  new URL('../images/metodo06.png', import.meta.url).href
      }
    ]
  },
  de: {
    title: "Wenn du alles über deine Anlage wissen könntest – was wäre es?",
    subtitle: "Die Methode zur Transformation",
    steps: [
      {
        title: "1. Erste Bewertung",
        content:
          "Wir führen eine detaillierte Analyse der Digitalisierungsbedürfnisse durch...",
        image:  new URL('../images/metodo01.png', import.meta.url).href
      },
      {
        title: "2. Strategische Planung",
        content:
          "Wir definieren klare Ziele und erstellen einen Aktionsplan...",
        image: new URL('../images/metodo02.png', import.meta.url).href
      },
      {
        title: "3. Technologiewahl",
        content:
          "Wir wählen die besten Werkzeuge und Technologieplattformen...",
        image:  new URL('../images/metodo03.png', import.meta.url).href
      },
      {
        title: "4. Umsetzung",
        content:
          "Wir implementieren die ausgewählten Technologien...",
        image: new URL('../images/metodo04.png', import.meta.url).href
      },
      {
        title: "5. Schulung",
        content:
          "Wir schulen dein Team im Umgang mit den neuen Tools...",
        image:  new URL('../images/metodo05.png', import.meta.url).href
      },
      {
        title: "6. Überwachung und Optimierung",
        content:
          "Wir überwachen die Ergebnisse in Echtzeit und optimieren...",
        image:  new URL('../images/metodo06.png', import.meta.url).href
      }
    ]
  }
} 


export const founders = [
  {
    id: 1,
    name: {
      es: "Alicia Ramírez Mata",
      en: "Alicia Ramírez Mata",
      de: "Alicia Ramírez Mata",
    },
    position: {
      es: "CEO & Cofundadora",
      en: "CEO & Co-founder",
      de: "CEO & Mitgründerin",
    },
    image:new URL('../images/alice.png', import.meta.url).href,
    description: {
      es: `Alicia Ramírez Mata es ingeniera mecatrónica mexicana con más de 17 años de experiencia en automatización, control de procesos e implementación de tecnologías de Industria 4.0. Fundadora y directora general de Frenkel Engineering, empresa que desde hace más de cinco años impulsa la automatización, digitalización e inteligencia artificial industrial en México. A lo largo de su trayectoria ha liderado proyectos que marcaron un antes y un después en la modernización de plantas industriales, contribuyendo al desarrollo de soluciones tecnológicas que hoy forman parte del ecosistema de transformación digital del país. Su liderazgo ha sido reconocido por Control Engineering con los premios System Integrators Giants 2024 y Engineering Leader Under 40, y ha representado a México en el programa Partnering in Business with Germany, promoviendo además la participación de más mujeres en STEM a través de mentorías y conferencias internacionales.`,
      en: `Alicia Ramírez Mata is a Mexican mechatronics engineer with more than 17 years of experience in automation, process control, and the implementation of Industry 4.0 technologies. She is the founder and CEO of Frenkel Engineering, a company that for over five years has been driving industrial automation, digitalization, and artificial intelligence in Mexico.
Throughout her career, she has led projects that marked a turning point in the modernization of industrial plants, contributing to the development of technological solutions that are now part of the country’s digital transformation ecosystem.
Her leadership has been recognized by Control Engineering with the System Integrator Giants 2024 and Engineering Leader Under 40 awards. She has also represented Mexico in the Partnering in Business with Germany program and actively promotes the participation of more women in STEM through mentoring and international conferences.`,
      de: `Alicia Ramírez Mata ist eine mexikanische Mechatronikingenieurin mit mehr als 17 Jahren Erfahrung in der Automatisierung, Prozesssteuerung und Implementierung von Technologien der Industrie 4.0. Sie ist Gründerin und Geschäftsführerin von Frenkel Engineering, einem Unternehmen, das seit über fünf Jahren die industrielle Automatisierung, Digitalisierung und künstliche Intelligenz in Mexiko vorantreibt.
Im Laufe ihrer Karriere hat sie Projekte geleitet, die einen Wendepunkt in der Modernisierung industrieller Anlagen markierten, und damit zur Entwicklung technologischer Lösungen beigetragen, die heute Teil des digitalen Transformationsökosystems des Landes sind.
Ihr Führungsstil wurde von Control Engineering mit den Auszeichnungen System Integrator Giants 2024 und Engineering Leader Under 40 gewürdigt. Außerdem hat sie Mexiko im Programm Partnering in Business with Germany vertreten und engagiert sich durch Mentoring und internationale Konferenzen für die stärkere Beteiligung von Frauen in MINT-Berufen.`
    }
  },
  {
    id: 2,
    name: {
      es: "Luis Enrique Solís Díaz",
      en: "Luis Enrique Solís Díaz",
      de: "Luis Enrique Solís Díaz",
    },
    position: {
      es: "CFO & Cofundador",
      en: "CFO & Co-founder",
      de: "CFO & Mitgründer",
    },
    image: new URL('../images/luis.png', import.meta.url).href,
    description: {
      es: `Luis Enrique Solís Díaz es administrador de empresas con amplia experiencia en planeación estratégica, finanzas corporativas y gestión de operaciones. Como cofundador de Frenkel, ha sido clave en el diseño de la estructura financiera y operativa que sustenta el crecimiento sostenible de la empresa.
Antes de fundar Frenkel, Luis trabajó en empresas del sector industrial y comercial, donde lideró proyectos de control financiero, optimización de recursos y análisis de rentabilidad. Su visión empresarial, combinada con una sólida capacidad de ejecución, ha permitido a Frenkel escalar proyectos complejos con orden, eficiencia y visión de largo plazo.`,
      en: `Luis Enrique Solís Díaz is a business administrator with extensive experience in strategic planning, corporate finance, and operations management. As co-founder of Frenkel, he has played a key role in designing the financial and operational structure that supports the company’s sustainable growth.
Before founding Frenkel, Luis worked in industrial and commercial companies, where he led projects in financial control, resource optimization, and profitability analysis. His business vision, combined with strong execution capabilities, has enabled Frenkel to scale complex projects with order, efficiency, and long-term vision.`,
      de: `Luis Enrique Solís Díaz ist Betriebswirt mit umfassender Erfahrung in strategischer Planung, Unternehmensfinanzen und Betriebsführung. Als Mitgründer von Frenkel war er maßgeblich an der Entwicklung der finanziellen und operativen Struktur beteiligt, die das nachhaltige Wachstum des Unternehmens trägt.
Vor der Gründung von Frenkel arbeitete Luis in Unternehmen des Industrie- und Handelssektors, wo er Projekte im Finanzcontrolling, in der Ressourcenoptimierung und in der Rentabilitätsanalyse leitete. Seine unternehmerische Vision, gepaart mit starker Umsetzungskompetenz, hat es Frenkel ermöglicht, komplexe Projekte geordnet, effizient und mit Weitblick zu skalieren.`
    }
  }
]

export const team = [
  {
    id: 1,
    image: new URL('../images/ivan.png', import.meta.url).href,
    name: {
      es: "Ivan Guerrero",
      en: "Ivan Guerrero",
      de: "Ivan Guerrero"
    },
    position: {
      es: "Director de Ventas",
      en: "Sales Director",
      de: "Vertriebsleiter"
    },
    description: {
      es: `Con sólida experiencia en desarrollo de negocios tecnológicos e industriales, Ivan lidera las estrategias comerciales de Frenkel con un enfoque técnico y consultivo. Ha participado activamente en proyectos de digitalización, automatización e Industria 4.0 en sectores como alimentos, bebidas y energía. Además, cuenta con experiencia en instrumentación industrial, lo que le permite ofrecer soluciones integrales alineadas a las necesidades operativas del cliente.`,
      en: `With solid experience in technological and industrial business development, Ivan leads Frenkel's commercial strategies with a technical and consultative approach. He has actively participated in digitization, automation, and Industry 4.0 projects in sectors such as food, beverages, and energy. He also has experience in industrial instrumentation, allowing him to offer comprehensive solutions aligned with customer operational needs.`,
      de: `Mit umfassender Erfahrung in der Entwicklung von Technologie- und Industriegeschäften leitet Ivan die kommerziellen Strategien von Frenkel mit einem technischen und beratenden Ansatz. Er hat aktiv an Digitalisierungs-, Automatisierungs- und Industrie-4.0-Projekten in Branchen wie Lebensmittel, Getränke und Energie teilgenommen. Darüber hinaus verfügt er über Erfahrung in der Industrieinstrumentierung, was es ihm ermöglicht, umfassende Lösungen anzubieten, die auf die betrieblichen Bedürfnisse des Kunden abgestimmt sind.`
    }
  },
  {
    id: 2,
    image: new URL('../images/victor.png', import.meta.url).href,
    name: {
      es: "Víctor Santillán",
      en: "Víctor Santillán",
      de: "Víctor Santillán"
    },
    position: {
      es: "Director de Automatización",
      en: "Automation Director",
      de: "Leiter Automatisierung"
    },
    description: {
      es: `Cuenta con más de 15 años de experiencia en automatización de procesos y 5 años liderando proyectos de Industria 4.0. Participó en el arranque de una planta de producción de bebidas de clase mundial, logrando una implementación récord a nivel global. Especialista en sistemas Siemens y Braumat, dirige un equipo multidisciplinario con enfoque en eficiencia, integración y alto desempeño operativo.`,
      en: `He has more than 15 years of experience in process automation and 5 years leading Industry 4.0 projects. He participated in the startup of a world-class beverage production plant, achieving a record global implementation. A specialist in Siemens and Braumat systems, he leads a multidisciplinary team focused on efficiency, integration, and high operational performance.`,
      de: `Er verfügt über mehr als 15 Jahre Erfahrung in der Prozessautomatisierung und 5 Jahre in der Leitung von Industrie-4.0-Projekten. Er war am Start einer Weltklasse-Getränkeproduktionsanlage beteiligt und erreichte eine globale Rekordimplementierung. Als Spezialist für Siemens- und Braumat-Systeme leitet er ein multidisziplinäres Team mit Fokus auf Effizienz, Integration und hohe operative Leistung.`
    }
  },
  
  {
    id: 4,
    image: new URL('../images/dayna.png', import.meta.url).href,
    name: {
      es: "Dayna Fosado",
      en: "Dayna Fosado",
      de: "Dayna Fosado"
    },
    position: {
      es: "Ingeniera de Automatización",
      en: "Automation Engineer",
      de: "Automatisierungsingenieurin"
    },
    description: {
      es: `Ingeniera especializada en automatización de procesos industriales. Dayna forma parte del equipo técnico encargado del diseño, implementación y puesta en marcha de soluciones con PLC, HMI y sistemas de control distribuido. Con enfoque en calidad y precisión, colabora en proyectos de mejora continua y digitalización en campo.`,
      en: `Engineer specialized in industrial process automation. Dayna is part of the technical team responsible for designing, implementing, and commissioning solutions with PLC, HMI, and distributed control systems. With a focus on quality and precision, she collaborates on continuous improvement and digitalization projects in the field.`,
      de: `Ingenieurin mit Spezialisierung auf die Automatisierung industrieller Prozesse. Dayna ist Teil des technischen Teams, das für die Entwicklung, Implementierung und Inbetriebnahme von Lösungen mit SPS, HMI und verteilten Steuerungssystemen verantwortlich ist. Mit Fokus auf Qualität und Präzision arbeitet sie an Projekten zur kontinuierlichen Verbesserung und Digitalisierung im Feld mit.`
    }
  },
  {
    id: 5,
    image:new URL('../images/diego.png', import.meta.url).href,
    name: {
      es: "Diego González",
      en: "Diego González",
      de: "Diego González"
    },
    position: {
      es: "Ingeniero de Automatización",
      en: "Automation Engineer",
      de: "Automatisierungsingenieur"
    },
    description: {
      es: `Diego se desempeña como especialista técnico en automatización, participando en la programación, configuración y soporte de sistemas de control para procesos productivos. Con conocimientos en tecnologías Siemens y experiencia en integración de soluciones industriales, es pieza clave en proyectos de modernización y eficiencia operativa.`,
      en: `Diego works as a technical specialist in automation, participating in programming, configuring, and supporting control systems for production processes. With knowledge in Siemens technologies and experience in integrating industrial solutions, he is a key player in modernization and operational efficiency projects.`,
      de: `Diego arbeitet als technischer Spezialist für Automatisierung und ist an der Programmierung, Konfiguration und Unterstützung von Steuerungssystemen für Produktionsprozesse beteiligt. Mit Kenntnissen in Siemens-Technologien und Erfahrung in der Integration industrieller Lösungen ist er eine Schlüsselperson in Projekten zur Modernisierung und operativen Effizienz.`
    }
  },
  {
    id: 6,
    image: new URL('../images/alejandro.png', import.meta.url).href,
    name: {
      es: "Alejandro García",
      en: "Alejandro García",
      de: "Alejandro García"
    },
    position: {
      es: "Ingeniero de Automatización",
      en: "Automation Engineer",
      de: "Automatisierungsingenieur"
    },
    description: {
      es: `Alejandro se especializa en soluciones de automatización basadas en tecnología Rockwell. Participa activamente en la configuración, programación y puesta en marcha de sistemas de control industrial, aportando un enfoque técnico y estructurado que contribuye a la eficiencia de los procesos.`,
      en: `Alejandro specializes in automation solutions based on Rockwell technology. He actively participates in configuring, programming, and commissioning industrial control systems, contributing a technical and structured approach that enhances process efficiency.`,
      de: `Alejandro ist auf Automatisierungslösungen mit Rockwell-Technologie spezialisiert. Er ist aktiv an der Konfiguration, Programmierung und Inbetriebnahme industrieller Steuerungssysteme beteiligt und trägt mit einem technischen und strukturierten Ansatz zur Prozesseffizienz bei.`
    }
  },
  {
    id: 7,
    image: new URL('../images/gustavo.png', import.meta.url).href,
    name: {
      es: "Gustavo Navarrete",
      en: "Gustavo Navarrete",
      de: "Gustavo Navarrete"
    },
    position: {
      es: "Director de Digitalización",
      en: "Digitalization Director",
      de: "Leiter Digitalisierung"
    },
    description: {
      es: `Lidera el desarrollo e implementación de soluciones digitales en Frenkel, incluyendo sistemas de adquisición de datos, análisis en tiempo real y visualización inteligente. Con sólida experiencia en transformación digital e integración IT-OT, Gustavo impulsa proyectos de Industria 4.0 enfocados en eficiencia, trazabilidad y toma de decisiones basada en datos.`,
      en: `He leads the development and implementation of digital solutions at Frenkel, including data acquisition systems, real-time analysis, and smart visualization. With solid experience in digital transformation and IT-OT integration, Gustavo drives Industry 4.0 projects focused on efficiency, traceability, and data-driven decision-making.`,
      de: `Er leitet die Entwicklung und Implementierung digitaler Lösungen bei Frenkel, einschließlich Datenerfassungssystemen, Echtzeitanalyse und intelligenter Visualisierung. Mit umfassender Erfahrung in digitaler Transformation und IT-OT-Integration treibt Gustavo Industrie-4.0-Projekte mit Schwerpunkt auf Effizienz, Rückverfolgbarkeit und datenbasierte Entscheidungsfindung voran.`
    }
  },
  {
    id: 8,
    image: new URL('../images/abril.png', import.meta.url).href,
    name: {
      es: "Abril Sánchez",
      en: "Abril Sánchez",
      de: "Abril Sánchez"
    },
    position: {
      es: "Ingeniera de Digitalización",
      en: "Digitalization Engineer",
      de: "Digitalisierungsingenieurin"
    },
    description: {
      es: `Abril participa activamente en el diseño e implementación de plataformas digitales para monitoreo y análisis industrial. Su experiencia incluye integración de sensores, protocolos de comunicación industrial, dashboards y modelos analíticos. Colabora en proyectos de transformación digital centrados en el valor operativo y el acceso inteligente a la información.`,
      en: `Abril actively participates in the design and implementation of digital platforms for industrial monitoring and analysis. Her experience includes sensor integration, industrial communication protocols, dashboards, and analytical models. She collaborates on digital transformation projects focused on operational value and smart access to information.`,
      de: `Abril ist aktiv an der Entwicklung und Implementierung digitaler Plattformen für industrielles Monitoring und Analyse beteiligt. Ihre Erfahrung umfasst die Integration von Sensoren, industrielle Kommunikationsprotokolle, Dashboards und analytische Modelle. Sie arbeitet an Digitalisierungsprojekten mit, die sich auf operativen Wert und intelligenten Informationszugang konzentrieren.`
    }
  }
];
export const certifications = [
  
  {
    id: 2,
    img: new URL('../images/cert-siemens-pcs7.png', import.meta.url).href,
    alt: 'Siemens PCS 7 Certification',
    url: 'https://support.industry.siemens.com/cs/document/104943001/simatic-pcs-7-training-overview'
  },
  {
    id: 3,
    img: new URL('../images/cert-siemens-braumat.png', import.meta.url).href,
    alt: 'Siemens Braumat Certification',
    url: 'https://www.sitrain-learning.siemens.com/DE/en/rw16760/braumat-basic'
  },
  {
    id: 4,
    img: new URL('../images/cert-siemens-plc-scada.png', import.meta.url).href,
    alt: 'Siemens PLC & SCADA Certification',
    url: 'https://www.sitrain-learning.siemens.com/global/en/portfolio/automation/simatic'
  },
  {
    id: 5,
    img: new URL('../images/cert-siemens-tia-portal.png', import.meta.url).href,
    alt: 'Siemens TIA Portal Certification',
    url: 'https://www.sitrain-learning.siemens.com/global/en/portfolio/automation/tia-portal'
  },
  {
    id: 6,
    img: new URL('../images/cert-rockwell-csi.png', import.meta.url).href,
    alt: 'Rockwell Automation Certified System Integrator',
    url: 'https://www.rockwellautomation.com/en-us/company/partnernetwork/programs/system-integrator.html'
  },
  {
    id: 7,
    img: new URL('../images/cert-nodered.png', import.meta.url).href,
    alt: 'Node-RED Industrial IoT Integrator',
    url: 'https://nodered.org/'
  },
  {
    id: 8,
    img: new URL('../images/cert-grafana.png', import.meta.url).href,
    alt: 'Grafana Certified',
    url: 'https://grafana.com/training/'
  },
  {
    id: 9,
    img: new URL('../images/cert-aws-ml.png', import.meta.url).href,
    alt: 'AWS Certified Machine Learning – Specialty',
    url: 'https://aws.amazon.com/certification/certified-machine-learning-specialty/'
  },
  {
    id: 10,
    img: new URL('../images/cert-azure-ai-engineer.png', import.meta.url).href,
    alt: 'Microsoft Certified: Azure AI Engineer Associate',
    url: 'https://learn.microsoft.com/credentials/certifications/azure-ai-engineer/'
  },
  {
    id: 11,
    img: new URL('../images/cert-gcp-ml-engineer.png', import.meta.url).href,
    alt: 'Google Cloud Professional Machine Learning Engineer',
    url: 'https://cloud.google.com/certification/machine-learning-engineer'
  }
];


export const partners = [
  {
    id: 1,
    name: 'BOYCO',
    img: new URL('../images/FRK-partner-boyco.png', import.meta.url).href,
    alt: 'BOYCO Ingeniería',
    url: 'https://www.boyco.com.mx/' 
  },
  {
    id: 2,
    name: 'Industrias Lowe',
    img: new URL('../images/FRK-partner-industrias-lowe.png', import.meta.url).href,
    alt: 'Industrias Lowe',
    url: 'https://www.industriaslowe.com/'
  },
  {
    id: 3,  
    name: 'Siemens',
    img: new URL('../images/FRK-partner-siemens.png', import.meta.url).href,
    alt: 'Siemens',
    url: 'https://www.siemens.com/'
  },
  {
    id: 4,
    name: 'Rockwell Automation',
    img: new URL('../images/FRK-partner-rockwell-automation.png', import.meta.url).href,
    alt: 'Rockwell Automation',
    url: 'https://www.rockwellautomation.com/'
  },
  {
    id: 5,
    name: 'ARMechatronics',
    img: new URL('../images/FRK-partner-armechatronics.png', import.meta.url).href,
    alt: 'ARMechatronics',
    url: 'https://www.armechatronics.com/'
  },
  {
    id: 6,
    name: 'Node-RED',
    img: new URL('../images/FRK-partner-node-red.png', import.meta.url).href,
    alt: 'Node-RED',
    url: 'https://nodered.org/'
  },
  {
    id: 7,
    name: 'Grafana',
    img: new URL('../images/FRK-partner-grafana.png', import.meta.url).href,
    alt: 'Grafana',
    url: 'https://grafana.com/'
  }
];




export const cursosDetalles = [
 
   {
    id: 20250728,
    slug: 'braumat-v7',
    createdAt: '2025-07-28T00:00:00Z',
    idioma: ['es', 'en', 'de'],
    categoria: {
      es: ['Automatización y Control'],
      en: ['Automation and Control'],
      de: ['Automatisierung und Steuerung']
    },
    tecnologia: 'Siemens',
    modalidad: ['remoto', 'presencial'],
    nivel: 'Intermedio',
    tags: {
      es: ['PLC', 'SCADA', 'Braumat', 'automatización', 'Siemens'],
      en: ['PLC', 'SCADA', 'Braumat', 'automation', 'Siemens'],
      de: ['PLC', 'SCADA', 'Braumat', 'Automatisierung', 'Siemens']
    },
    nombre: {
      es: 'Braumat V7',
      en: 'Braumat V7',
      de: 'Braumat V7'
    },
    descripcion: {
      es: 'Aprende a configurar y dar soporte a sistemas Siemens Braumat V7 en entornos industriales.',
      en: 'Learn how to configure and support Siemens Braumat V7 systems in industrial environments.',
      de: 'Lerne, wie du Siemens Braumat V7 Systeme in industriellen Umgebungen konfigurierst und betreust.'
    },
    queAprenderas: {
      es: [
        'Configurar objetos tecnológicos en Braumat',
        'Operar sistemas de recetas, órdenes y mensajes',
        'Diagnosticar y dar mantenimiento a sistemas de control',
        'Utilizar herramientas adicionales del sistema'
      ]
    },
    contenido: {
      es: [
        { type: 'heading', text: 'Temario' },
        { type: 'list', text: 'Descripción del sistema' },
        { type: 'list', text: 'Objetos tecnológicos y primeros pasos' },
        { type: 'list', text: 'Sistema de recetas, órdenes y mensajes' },
        { type: 'list', text: 'Diagnóstico, reportes y herramientas adicionales' },
        { type: 'heading', text: 'Requisitos técnicos' },
        { type: 'list', text: 'Windows 7 o 10, 8 GB de RAM, 50 GB libres' },
        { type: 'list', text: 'VMWare Player 15 instalado' }
      ]
    },
    duracion: '1 semana',
    horario: { es: 'Lunes a Viernes de 9:00 a 16:00' },
    proximaFecha: 'Por definir',
    costo: { cantidad: 1400, moneda: 'USD', incluyeIVA: false },
    incluye: {
      es: [
        'Constancia de participación',
        'Máquina virtual con software instalado',
        'Manual del fabricante y notas de capacitación'
      ]
    },
    urlImagen: new URL('@/assets/images/cursos.png', import.meta.url).href,
    rating: 4.8
  },

  // --- NODE-RED/INFLUX/GRAFANA (NIG) ---
  {
    id: 20240819,
    slug: 'node-red-influx-grafana',
    createdAt: '2024-08-19T00:00:00Z',
    idioma: ['es'],
    categoria: { es: ['Automatización y Control'] },
    tecnologia: 'Node-RED, InfluxDB, Grafana',
    modalidad: ['remoto', 'presencial'],
    nivel: 'Básico',
    tags: { es: ['Node-RED', 'InfluxDB', 'Grafana', 'IoT', 'Dashboard'] },
    nombre: { es: 'Node-RED / Influx / Grafana (NIG)' },
    descripcion: {
      es: 'Curso especializado para ingeniería de proyectos y desarrollo interesados en herramientas IoT industriales. Aprende programación, diagnóstico y desarrollo de funciones con Node-RED, InfluxDB y Grafana.'
    },
    queAprenderas: {
      es: [
        'Introducción a Node-RED y su interfaz',
        'Principios de programación en bloques y JavaScript',
        'Conexión con PLCs, MQTT, OPC-UA y servicios API',
        'Almacenamiento de datos y dashboards con InfluxDB y Grafana'
      ]
    },
    contenido: {
      es: [
        { type: 'heading', text: 'Temario' },
        { type: 'list', text: 'Primeros pasos en Node-RED' },
        { type: 'list', text: 'Introducción a JavaScript y JSON en Node-RED' },
        { type: 'list', text: 'Programación en bloques y estructurada' },
        { type: 'list', text: 'Manejo de bloques especiales: S7, MQTT, OPC-UA, Telegram, Email' },
        { type: 'list', text: 'Servicios API: Consumo, creación y lectura' },
        { type: 'list', text: 'Almacenamiento de datos: CSV, InfluxDB, MySQL' },
        { type: 'list', text: 'Querys en InfluxDB y operaciones avanzadas' },
        { type: 'list', text: 'Dashboards en Grafana: paneles y variables dinámicas' },
        { type: 'list', text: 'Implementación industrial en IOT 2050/Edge Device' },
        { type: 'heading', text: 'Requisitos técnicos' },
        { type: 'list', text: 'Conocimientos básicos en Windows 10' },
        { type: 'list', text: 'Conocimientos básicos en automatización o programación de PLCs' },
        { type: 'list', text: 'Laptop con VMWare Player 17+, Windows 10+, 8GB RAM, 100GB libres, Dual Core 2.9GHz+' }
      ]
    },
    duracion: '4 días',
    horario: { es: 'Lunes a Jueves de 9:00 a 16:00' },
    proximaFecha: '19 al 22 de agosto de 2024',
    costo: { cantidad: 9500, moneda: 'MXN', incluyeIVA: false },
    incluye: {
      es: [
        'Constancia de participación',
        'Máquina virtual con software',
        'Material de trabajo',
        'Manual y notas del fabricante'
      ]
    },
    urlImagen: new URL('@/assets/images/NODE-RED_INFLUX_GRAFANA.png', import.meta.url).href,
    rating: 4.7
  },

  // --- PCS7 BÁSICO Y AVANZADO ---
  {
    id: 20240408,
    slug: 'pcs7-basico-avanzado',
    createdAt: '2024-04-08T00:00:00Z',
    idioma: ['es'],
    categoria: { es: ['Automatización y Control'] },
    tecnologia: 'Siemens PCS7',
    modalidad: ['remoto', 'presencial'],
    nivel: 'Intermedio-Avanzado',
    tags: { es: ['PCS7', 'DCS', 'automatización', 'proceso', 'Siemens'] },
    nombre: { es: 'PCS7 Básico y Avanzado' },
    descripcion: {
      es: 'Curso completo en PCS7 para ingeniería y mantenimiento: soporte, programación, desarrollo y mantenimiento de sistemas de control de procesos.'
    },
    queAprenderas: {
      es: [
        'Diseño y configuración de arquitecturas PCS7',
        'Redes, hardware y control avanzado',
        'Uso de bibliotecas, secuencias y monitoreo OS',
        'Ingeniería en masa, integración de redes y clientes'
      ]
    },
    contenido: {
      es: [
        { type: 'heading', text: 'Temario' },
        { type: 'list', text: 'Generalidades y diseño de sistema PCS7' },
        { type: 'list', text: 'Configuración inicial y hardware' },
        { type: 'list', text: 'Redes, NetPro y conexiones' },
        { type: 'list', text: 'Control CFC y bibliotecas APL' },
        { type: 'list', text: 'Monitoreo y operación (OS)' },
        { type: 'list', text: 'Secuencias (SFC), control manual y automático' },
        { type: 'list', text: 'Redundancias, integración Profibus/Profinet' },
        { type: 'list', text: 'Ingeniería en masa, Project Editor y personalización OS' },
        { type: 'list', text: 'Alarmas, históricos, sincronización de hora' },
        { type: 'heading', text: 'Requisitos técnicos' },
        { type: 'list', text: 'Conocimientos básicos en Windows 10' },
        { type: 'list', text: 'Conocimientos en DCS y PLCs' },
        { type: 'list', text: 'Laptop con VMWare Player 15+, Windows 7/10/11, 8GB RAM, 50GB+ libres' }
      ]
    },
    duracion: '2 semanas',
    horario: { es: 'Lunes a Viernes de 9:00 a 16:00' },
    proximaFecha: '8 al 19 de Abril 2024',
    costo: { cantidad: 20500, moneda: 'MXN', incluyeIVA: false },
    incluye: {
      es: [
        'Constancia de participación',
        'Máquina virtual con software instalado',
        'Manual y notas del fabricante'
      ]
    },
    urlImagen: new URL('@/assets/images/PCS7_BASICO.png', import.meta.url).href,
    rating: 4.8
  },

  // --- STEP7 S7-400/300 ---
  {
    id: 20230722,
    slug: 'step7-s7-400-300',
    createdAt: '2023-07-22T00:00:00Z',
    idioma: ['es'],
    categoria: { es: ['Automatización y Control'] },
    tecnologia: 'Siemens STEP7',
    modalidad: ['remoto', 'presencial'],
    nivel: 'Básico',
    tags: { es: ['STEP7', 'Siemens', 'S7-300', 'S7-400', 'PLC'] },
    nombre: { es: 'STEP 7 para S7-400 y S7-300' },
    descripcion: {
      es: 'Aprende a programar, configurar y dar soporte a sistemas Siemens STEP 7 para las familias S7-400 y S7-300.'
    },
    queAprenderas: {
      es: [
        'Configuración de hardware y bloques',
        'Programación binaria, digital y analógica',
        'Comunicación y respaldo de programas',
        'Diagnóstico y manejo de alarmas'
      ]
    },
    contenido: {
      es: [
        { type: 'heading', text: 'Temario' },
        { type: 'list', text: 'Familias de SIMATIC S7' },
        { type: 'list', text: 'Uso de SIMATIC Manager' },
        { type: 'list', text: 'Configuración de Hardware' },
        { type: 'list', text: 'Arquitectura de bloques' },
        { type: 'list', text: 'Operaciones binarias y digitales' },
        { type: 'list', text: 'Manejo de datos y alarmas' },
        { type: 'list', text: 'Comunicación con PLC' },
        { type: 'heading', text: 'Requisitos técnicos' },
        { type: 'list', text: 'Conocimientos básicos en Windows 10' },
        { type: 'list', text: 'Conocimientos básicos en automatización o PLCs' },
        { type: 'list', text: 'Laptop con VMWare Player 17+, Windows 10+, 8GB RAM, 100GB libres, Dual Core 2.9GHz+' }
      ]
    },
    duracion: '3 días',
    horario: { es: 'Lunes a Miércoles de 9:00 a 16:30' },
    proximaFecha: '22 al 24 de Julio 2023',
    costo: { cantidad: 8000, moneda: 'MXN', incluyeIVA: false },
    incluye: {
      es: [
        'Constancia de participación',
        'Máquina virtual con software instalado',
        'Manual del fabricante y notas de capacitación'
      ]
    },
    urlImagen: new URL('@/assets/images/STEP7.jpeg', import.meta.url).href,
    rating: 4.7
  },

  // --- TIA PORTAL AVANZADO ---
  {
    id: 20240902,
    slug: 'tia-portal-avanzado',
    createdAt: '2024-09-02T00:00:00Z',
    idioma: ['es'],
    categoria: { es: ['Automatización y Control'] },
    tecnologia: 'Siemens TIA Portal',
    modalidad: ['remoto', 'presencial'],
    nivel: 'Avanzado',
    tags: { es: ['TIA Portal', 'Avanzado', 'automatización', 'Siemens'] },
    nombre: { es: 'TIA Portal Avanzado' },
    descripcion: {
      es: 'Curso avanzado de TIA Portal para soporte, programación, diagnóstico y seguridad funcional en sistemas Siemens S7-1500.'
    },
    queAprenderas: {
      es: [
        'Creación de estructuras de datos complejas',
        'Manejo de librerías y funciones avanzadas',
        'Comunicación CPU-CPU, diagnóstico y administración de recetas',
        'Implementación y configuración avanzada en PROFINET IO'
      ]
    },
    contenido: {
      es: [
        { type: 'heading', text: 'Temario' },
        { type: 'list', text: 'Estructuras de datos complejas' },
        { type: 'list', text: 'Librerías y manejo de errores' },
        { type: 'list', text: 'Comunicación y diagnóstico avanzado' },
        { type: 'list', text: 'Administración de recetas (HMI)' },
        { type: 'list', text: 'Configuración avanzada PROFINET IO' },
        { type: 'list', text: 'Seguridad funcional y herramientas de ingeniería' },
        { type: 'heading', text: 'Requisitos técnicos' },
        { type: 'list', text: 'Conocimientos básicos en Windows 10' },
        { type: 'list', text: 'Conocimientos en automatización y PLCs' },
        { type: 'list', text: 'Laptop con VMWare Player 17+, Windows 10+, 8GB RAM, 100GB libres, Dual Core 2.9GHz+' }
      ]
    },
    duracion: '3 días',
    horario: { es: 'Lunes a Miércoles de 9:00 a 16:00' },
    proximaFecha: '2 al 4 de septiembre de 2024',
    costo: { cantidad: 7500, moneda: 'MXN', incluyeIVA: false },
    incluye: {
      es: [
        'Constancia de participación',
        'Máquina virtual con software instalado',
        'Manual del fabricante y notas de capacitación'
      ]
    },
    urlImagen: new URL('@/assets/images/tia_avanzado.png', import.meta.url).href,
    rating: 4.7
  },

  // --- TIA PORTAL BÁSICO ---
  {
    id: 20240805,
    slug: 'tia-portal-basico',
    createdAt: '2024-08-05T00:00:00Z',
    idioma: ['es'],
    categoria: { es: ['Automatización y Control'] },
    tecnologia: 'Siemens TIA Portal',
    modalidad: ['remoto', 'presencial'],
    nivel: 'Básico',
    tags: { es: ['TIA Portal', 'Básico', 'automatización', 'Siemens'] },
    nombre: { es: 'TIA Portal Básico' },
    descripcion: {
      es: 'Curso básico de TIA Portal para personal de ingeniería, programación y mantenimiento de sistemas Siemens.'
    },
    queAprenderas: {
      es: [
        'Uso y componentes del TIA Portal',
        'Programación en STEP 7 y WinCC',
        'Diagnóstico, configuración y documentación de hardware',
        'Manejo de bloques, funciones y E/S PROFINET'
      ]
    },
    contenido: {
      es: [
        { type: 'heading', text: 'Temario' },
        { type: 'list', text: 'Visión general de SIMATIC S7' },
        { type: 'list', text: 'Componentes y fundamentos de programación' },
        { type: 'list', text: 'Configuración de hardware y módulos' },
        { type: 'list', text: 'Programación y diagnóstico de bloques' },
        { type: 'list', text: 'Operaciones binarias y digitales' },
        { type: 'list', text: 'Procesamiento de valores analógicos y multi-instancias' },
        { type: 'heading', text: 'Requisitos técnicos' },
        { type: 'list', text: 'Conocimientos básicos en Windows 10' },
        { type: 'list', text: 'Conocimientos en automatización y PLCs' },
        { type: 'list', text: 'Laptop con VMWare Player 17+, Windows 10+, 8GB RAM, 100GB libres, Dual Core 2.9GHz+' }
      ]
    },
    duracion: '4 días',
    horario: { es: 'Lunes a Jueves de 9:00 a 16:00' },
    proximaFecha: '05 al 08 de agosto de 2024',
    costo: { cantidad: 7000, moneda: 'MXN', incluyeIVA: false },
    incluye: {
      es: [
        'Constancia de participación',
        'Máquina virtual con software instalado',
        'Manual del fabricante y notas de capacitación'
      ]
    },
    urlImagen: new URL('@/assets/images/tia_portal_basico.png', import.meta.url).href,
    rating: 4.6
  },

  // --- WINCC UNIFIED SYSTEM ---
  {
    id: 20241126,
    slug: 'wincc-unified-system',
    createdAt: '2024-11-26T00:00:00Z',
    idioma: ['es'],
    categoria: { es: ['Automatización y Control'] },
    tecnologia: 'Siemens WinCC Unified',
    modalidad: ['remoto', 'presencial'],
    nivel: 'Intermedio',
    tags: { es: ['WinCC Unified', 'HMI', 'automatización', 'Siemens'] },
    nombre: { es: 'Simatic WINCC Unified System' },
    descripcion: {
      es: 'Especialízate en programación y mantenimiento de sistemas Simatic WINCC Unified: HMI, reporting, comunicación y dashboards industriales.'
    },
    queAprenderas: {
      es: [
        'Manejo de plantillas y navegación de pantallas',
        'Comunicación y scripting HMI',
        'Custom Web Control y reportes',
        'Configuración de paneles y cliente-servidor'
      ]
    },
    contenido: {
      es: [
        { type: 'heading', text: 'Temario' },
        { type: 'list', text: 'Basic Information' },
        { type: 'list', text: 'Device handling & Screen navigation' },
        { type: 'list', text: 'HMI Template Suite' },
        { type: 'list', text: 'Communication' },
        { type: 'list', text: 'Screen Engineering' },
        { type: 'list', text: 'Scripting' },
        { type: 'list', text: 'Custom Web Control' },
        { type: 'list', text: 'Reporting y PI Options' },
        { type: 'heading', text: 'Requisitos técnicos' },
        { type: 'list', text: 'Conocimientos básicos en Windows 10' },
        { type: 'list', text: 'Conocimientos en automatización y PLCs' },
        { type: 'list', text: 'Laptop con VMWare Player 15+, Windows 7/10, 16GB RAM, 100GB libres, Dual Core 2.9GHz+' }
      ]
    },
    duracion: '4 días',
    horario: { es: 'Martes a Viernes de 9:00 a 16:00' },
    proximaFecha: '26 al 29 de Noviembre',
    costo: { cantidad: 25000, moneda: 'MXN', incluyeIVA: false },
    incluye: {
      es: [
        'Constancia de participación',
        'Máquina virtual con software instalado',
        'Manual del fabricante y notas de capacitación'
      ]
    },
    urlImagen: new URL('@/assets/images/wincc.png', import.meta.url).href,
    rating: 4.9
  }
];

//UNIFICACION DE SERVICIOS
export const servicios = {
  // --- INDUSTRIA 4.0 ---
'industria-4-0': {
  slugs: {
    es: '/industria-4-0',
    en: '/industria-4-0',
    de: '/industria-4-0'
  },
  category: {
    es: 'Transformación Digital',
    en: 'Digital Transformation',
    de: 'Digitale Transformation'
  },
  images: {
    icon: new URL('@/assets/images/servicio01.svg', import.meta.url).href,
    iconHover: new URL('@/assets/images/servicio01-hover.svg', import.meta.url).href,
    // Imágenes por idioma, puedes cambiar la ruta específica en cada idioma si lo necesitas
    hero: {
      es: new URL('@/assets/images/hero_industria.png', import.meta.url).href,
      en: new URL('@/assets/images/hero_industria.png', import.meta.url).href,
      de: new URL('@/assets/images/hero_industria.png', import.meta.url).href
    },
    detalle: {
      es: new URL('@/assets/images/industria_servicio.png', import.meta.url).href,
      en: new URL('@/assets/images/industria_servicio.png', import.meta.url).href,
      de: new URL('@/assets/images/industria_servicio.png', import.meta.url).href
    },
    banner: {
      es: new URL('@/assets/images/servicios_banner.png', import.meta.url).href,
      en: new URL('@/assets/images/servicios_banner.png', import.meta.url).href,
      de: new URL('@/assets/images/servicios_banner.png', import.meta.url).href
    }
  },
  titles: {
    es: 'Industria 4.0',
    en: 'Industry 4.0',
    de: 'Industrie 4.0'
  },
  descriptions: {
    es: 'Implementamos soluciones completas de Industria 4.0, integrando tecnologías como IIoT, Big Data y automatización de procesos para transformar las plantas en fábricas inteligentes.',
    en: 'We implement complete Industry 4.0 solutions, integrating technologies like IIoT, Big Data, and automation to transform plants into smart factories.',
    de: 'Wir implementieren umfassende Industrie-4.0-Lösungen, integrieren Technologien wie IIoT, Big Data und Automatisierung, um Anlagen in intelligente Fabriken zu verwandeln.'
  },
  expertise: {
    es: 'Facilitamos la digitalización, el análisis predictivo y la optimización en tiempo real, mejorando la eficiencia operativa y la toma de decisiones.',
    en: 'We enable digitalization, predictive analytics, and real-time optimization, improving operational efficiency and decision-making.',
    de: 'Wir ermöglichen Digitalisierung, prädiktive Analytik und Echtzeitoptimierung und verbessern so die operative Effizienz und Entscheidungsfindung.'
  },
  detail: {
    es: {
      hero: {
        title: "Industria 4.0",
        image: new URL('@/assets/images/hero_industria.png', import.meta.url).href // hero por idioma
      },
      tabs: [
        {
          title: "Industria 4.0",
          image: new URL('@/assets/images/industria_servicio.png', import.meta.url).href, // detalle por idioma
          index: [
            { label: "Introducción", anchor: "introduccion" },
            { label: "Qué incluye el servicio", anchor: "incluye" },
            { label: "Ventajas", anchor: "ventajas" },
            { label: "Para quién", anchor: "para-quien" }
          ],
          introduccion: {
            content: `En Frenkel nos especializamos en la implementación de soluciones industriales inteligentes que permiten a las empresas avanzar hacia una digitalización total de sus procesos. Transformamos plantas tradicionales en operaciones conectadas, flexibles y eficientes, integrando tecnologías como Internet Industrial de las Cosas (IIoT), Big Data, inteligencia artificial, edge computing y automatización no invasiva.
Gracias a nuestra experiencia en entornos OT e IT, logramos que cada componente de la planta —desde sensores y PLCs hasta plataformas de visualización y análisis— funcione de forma optimizada, adaptándose a los desafíos reales de la industria moderna.`
          },
          incluye: {
            description: `Nuestro enfoque en Industria 4.0 se basa en una metodología integral, adaptada a las necesidades y madurez tecnológica de cada planta. Inicia con el diagnóstico de procesos y culmina con la operación de una infraestructura digital inteligente y escalable:`,
            items: [
              {
                title: "Análisis de la Compañía",
                content: "Realizamos un diagnóstico profundo de los sistemas actuales para detectar cuellos de botella, riesgos operativos y oportunidades de digitalización. Analizamos desde variables de proceso hasta conectividad OT/IT."
              },
              {
                title: "Planeación Estratégica",
                content: "Definimos una hoja de ruta digital alineada a tus metas operativas y de negocio. Diseñamos la evolución por etapas, permitiendo una transición modular, gradual y sin interrupciones."
              },
              {
                title: "Selección de Tecnología",
                content: "Recomendamos tecnologías que realmente se adaptan a tu operación: sensores IIoT, edge devices, sistemas de recolección de datos, visualización industrial (como Grafana), inteligencia artificial y analítica avanzada."
              },
              {
                title: "Aplicación de Tecnología",
                content: "Implementamos las soluciones seleccionadas, conectando datos desde el campo (PLCs, IO-Link, OPC UA) hasta plataformas web o móviles. Automatizamos tareas críticas, habilitamos mantenimiento predictivo y tomas de decisión basadas en datos."
              },
              {
                title: "Capacitación del Personal",
                content: "Entrenamos a operativos, técnicos y gerentes para garantizar una adopción exitosa. Enseñamos no solo a usar la tecnología, sino a aprovecharla como herramienta operativa diaria."
              },
              {
                title: "Monitoreo y Optimización",
                content: "Realizamos seguimiento post-implementación para asegurar que los sistemas sigan entregando valor. Ajustamos y mejoramos según evolución de procesos, crecimiento o nuevas necesidades."
              },
              {
                title: "Soluciones Personalizadas",
                content: "Si las plataformas estándar no son suficientes, diseñamos soluciones a medida que responden directamente a tu tipo de operación, industria y arquitectura existente."
              }
            ]
          },
          ventajas: {
            items: [
              "Optimización en tiempo real: Recolectamos, analizamos y visualizamos datos al instante para facilitar decisiones inmediatas y efectivas.",
              "Reducción de costos: Mejoramos la eficiencia operativa y reducimos desperdicio, consumo energético e interrupciones.",
              "Mantenimiento predictivo: Detectamos patrones de fallo antes de que ocurran, extendiendo la vida útil de tus equipos y reduciendo paros.",
              "Adaptación tecnológica constante: Nuestras soluciones están diseñadas para crecer con tu planta y adaptarse a nuevas tecnologías.",
              "Estrategia modular y no invasiva: Digitalizamos sin interrumpir procesos existentes, respetando la arquitectura actual y permitiendo mejoras progresivas."
            ]
          },
          paraQuien: {
            description: `Este servicio está diseñado para empresas industriales que desean convertir sus operaciones en plantas inteligentes, resilientes y basadas en datos. Algunos perfiles ideales son:`,
            perfiles: [
              "Plantas de bebidas, fermentación y destilados: Cervecerías, malterías o tequileras que buscan monitoreo de variables críticas, trazabilidad por lote, eficiencia energética y control de merma en tiempo real.",
              "Industrias de alimentos líquidos o a granel: Productores como Sucroliq que operan múltiples plantas y necesitan conectividad remota, visualización centralizada, control de proceso y mantenimiento predictivo.",
              "Operaciones con infraestructura moderna que desean dar el siguiente paso: Empresas que ya cuentan con PLCs Siemens, sistemas PCS7 o TIA Portal, y desean incorporar visualización, IA o analítica predictiva para escalar su productividad.",
              "Negocios en expansión o con planes de modernización: Empresas que están creciendo o diversificando su operación y requieren una estrategia de digitalización estructurada, que respete su arquitectura existente.",
              "Empresas con enfoque en sostenibilidad operativa: Plantas que buscan reducir consumo de energía, agua o materias primas mediante el uso inteligente de datos de proceso."
            ]
          }
        }
      ],
      banner: {
        image: new URL('@/assets/images/servicios_banner.png', import.meta.url).href, // banner por idioma
        content: `¿Tu empresa no encaja exactamente en estos perfiles?
En Frenkel, entendemos que cada operación industrial tiene retos y oportunidades únicos. Si tu empresa no se encuentra dentro de los rubros mencionados, ¡no te preocupes! Nuestro enfoque es flexible y adaptamos nuestras soluciones a diferentes sectores que buscan optimizar sus procesos a través de la digitalización, el análisis de datos y la automatización.
Contáctanos y descubre cómo podemos ayudarte a llevar tu operación al siguiente nivel, sin importar el giro o tamaño de tu negocio.`
      },
      cta: {
        title: "¿Listos para comenzar?",
        content: "Diseña tu proyecto con bases sólidas. Contáctanos y agenda una sesión con nuestros expertos en ingeniería para dar el primer paso hacia una operación más inteligente y eficiente.",
        button: "Enviar"
      }
    },
    en: {
      hero: {
        title: "Industry 4.0",
        image: new URL('@/assets/images/hero_industria.png', import.meta.url).href
      },
      tabs: [
        {
          title: "Industry 4.0",
          image: new URL('@/assets/images/industria_servicio.png', import.meta.url).href,
          index: [
            { label: "Introduction", anchor: "introduccion" },
            { label: "What the service includes", anchor: "incluye" },
            { label: "Advantages", anchor: "ventajas" },
            { label: "Who is it for", anchor: "para-quien" }
          ],
          introduccion: {
            content: `At Frenkel, we specialize in implementing smart industrial solutions that enable companies to move towards total digitalization of their processes. We transform traditional plants into connected, flexible, and efficient operations, integrating technologies such as Industrial Internet of Things (IIoT), Big Data, artificial intelligence, edge computing, and non-invasive automation.
Thanks to our experience in OT and IT environments, we ensure that every component of the plant—from sensors and PLCs to visualization and analysis platforms—works optimally, adapting to the real challenges of modern industry.`
          },
          incluye: {
            description: `Our Industry 4.0 approach is based on a comprehensive methodology, adapted to the needs and technological maturity of each plant. It begins with process diagnostics and culminates in the operation of an intelligent and scalable digital infrastructure:`,
            items: [
              {
                title: "Company Analysis",
                content: "We conduct a thorough diagnosis of current systems to detect bottlenecks, operational risks, and digitalization opportunities. We analyze everything from process variables to OT/IT connectivity."
              },
              {
                title: "Strategic Planning",
                content: "We define a digital roadmap aligned with your operational and business goals. We design evolution by stages, allowing for a modular, gradual, and uninterrupted transition."
              },
              {
                title: "Technology Selection",
                content: "We recommend technologies that truly fit your operation: IIoT sensors, edge devices, data collection systems, industrial visualization (like Grafana), artificial intelligence, and advanced analytics."
              },
              {
                title: "Technology Application",
                content: "We implement selected solutions, connecting data from the field (PLCs, IO-Link, OPC UA) to web or mobile platforms. We automate critical tasks, enable predictive maintenance, and data-driven decision making."
              },
              {
                title: "Staff Training",
                content: "We train operators, technicians, and managers to ensure successful adoption. We teach not only how to use technology but how to leverage it as a daily operational tool."
              },
              {
                title: "Monitoring and Optimization",
                content: "We provide post-implementation follow-up to ensure systems continue delivering value. We adjust and improve according to process evolution, growth, or new needs."
              },
              {
                title: "Custom Solutions",
                content: "If standard platforms are not enough, we design tailor-made solutions that directly respond to your type of operation, industry, and existing architecture."
              }
            ]
          },
          ventajas: {
            items: [
              "Real-time optimization: We collect, analyze, and visualize data instantly to facilitate immediate and effective decisions.",
              "Cost reduction: We improve operational efficiency and reduce waste, energy consumption, and interruptions.",
              "Predictive maintenance: We detect failure patterns before they occur, extending the life of your equipment and reducing downtime.",
              "Constant technological adaptation: Our solutions are designed to grow with your plant and adapt to new technologies.",
              "Modular and non-invasive strategy: We digitalize without interrupting existing processes, respecting current architecture and allowing for progressive improvements."
            ]
          },
          paraQuien: {
            description: `This service is designed for industrial companies that want to transform their operations into smart, resilient, and data-driven plants. Ideal profiles include:`,
            perfiles: [
              "Beverage, fermentation, and distillery plants: Breweries, malt houses, or tequila makers seeking monitoring of critical variables, batch traceability, energy efficiency, and real-time loss control.",
              "Liquid or bulk food industries: Producers like Sucroliq operating multiple plants and needing remote connectivity, centralized visualization, process control, and predictive maintenance.",
              "Operations with modern infrastructure ready to take the next step: Companies with Siemens PLCs, PCS7 or TIA Portal systems, looking to incorporate visualization, AI, or predictive analytics to scale productivity.",
              "Growing businesses or those with modernization plans: Companies expanding or diversifying operations that require a structured digitalization strategy, respecting their existing architecture.",
              "Companies focused on operational sustainability: Plants aiming to reduce energy, water, or raw material consumption through smart use of process data."
            ]
          }
        }
      ],
      banner: {
        image: new URL('@/assets/images/servicios_banner.png', import.meta.url).href,
        content: `Does your company not fit exactly into these profiles?
At Frenkel, we understand that every industrial operation has unique challenges and opportunities. If your company is not within the mentioned sectors, don't worry! Our approach is flexible and we adapt our solutions to different sectors seeking to optimize their processes through digitalization, data analysis, and automation.
Contact us and discover how we can help take your operation to the next level, regardless of your business's size or field.`
      },
      cta: {
        title: "Ready to get started?",
        content: "Design your project on solid foundations. Contact us and schedule a session with our engineering experts to take the first step towards a smarter and more efficient operation.",
        button: "Send"
      }
    },
    de: {
      hero: {
        title: "Industrie 4.0",
        image: new URL('@/assets/images/hero_industria.png', import.meta.url).href
      },
      tabs: [
        {
          title: "Industrie 4.0",
          image: new URL('@/assets/images/industria_servicio.png', import.meta.url).href,
          index: [
            { label: "Einführung", anchor: "introduccion" },
            { label: "Was der Service beinhaltet", anchor: "incluye" },
            { label: "Vorteile", anchor: "ventajas" },
            { label: "Für wen", anchor: "para-quien" }
          ],
          introduccion: {
            content: `Bei Frenkel sind wir auf die Implementierung intelligenter Industrielösungen spezialisiert, die Unternehmen ermöglichen, ihre Prozesse vollständig zu digitalisieren. Wir verwandeln traditionelle Anlagen in vernetzte, flexible und effiziente Betriebe, indem wir Technologien wie das Industrial Internet of Things (IIoT), Big Data, künstliche Intelligenz, Edge Computing und nicht-invasive Automatisierung integrieren.
Dank unserer Erfahrung in OT- und IT-Umgebungen stellen wir sicher, dass jede Komponente der Anlage – von Sensoren und SPS bis hin zu Visualisierungs- und Analyseplattformen – optimal funktioniert und sich an die realen Herausforderungen der modernen Industrie anpasst.`
          },
          incluye: {
            description: `Unser Ansatz für Industrie 4.0 basiert auf einer ganzheitlichen Methodik, die an die Bedürfnisse und den technologischen Reifegrad jeder Anlage angepasst ist. Sie beginnt mit der Prozessdiagnose und endet mit dem Betrieb einer intelligenten und skalierbaren digitalen Infrastruktur:`,
            items: [
              {
                title: "Unternehmensanalyse",
                content: "Wir führen eine gründliche Diagnose der aktuellen Systeme durch, um Engpässe, betriebliche Risiken und Digitalisierungschancen zu erkennen. Wir analysieren alles von Prozessvariablen bis hin zur OT/IT-Konnektivität."
              },
              {
                title: "Strategische Planung",
                content: "Wir definieren eine digitale Roadmap, die mit Ihren operativen und geschäftlichen Zielen übereinstimmt. Wir gestalten die Entwicklung in Phasen, sodass ein modularer, schrittweiser und unterbrechungsfreier Übergang möglich ist."
              },
              {
                title: "Technologiewahl",
                content: "Wir empfehlen Technologien, die wirklich zu Ihrem Betrieb passen: IIoT-Sensoren, Edge Devices, Datenerfassungssysteme, industrielle Visualisierung (wie Grafana), künstliche Intelligenz und fortschrittliche Analytik."
              },
              {
                title: "Technologieanwendung",
                content: "Wir implementieren die ausgewählten Lösungen, verbinden Daten aus dem Feld (SPS, IO-Link, OPC UA) mit Web- oder Mobilplattformen. Wir automatisieren kritische Aufgaben, ermöglichen vorausschauende Wartung und datengestützte Entscheidungsfindung."
              },
              {
                title: "Mitarbeiterschulung",
                content: "Wir schulen Bediener, Techniker und Manager, um eine erfolgreiche Einführung zu gewährleisten. Wir zeigen nicht nur die Nutzung der Technologie, sondern auch, wie sie als tägliches Werkzeug genutzt werden kann."
              },
              {
                title: "Überwachung und Optimierung",
                content: "Wir bieten Nachbetreuung nach der Implementierung, um sicherzustellen, dass die Systeme weiterhin einen Mehrwert liefern. Wir passen uns an Prozessentwicklungen, Wachstum oder neue Bedürfnisse an."
              },
              {
                title: "Maßgeschneiderte Lösungen",
                content: "Wenn Standardplattformen nicht ausreichen, entwerfen wir maßgeschneiderte Lösungen, die direkt auf Ihren Betrieb, Ihre Branche und Ihre bestehende Architektur zugeschnitten sind."
              }
            ]
          },
          ventajas: {
            items: [
              "Optimierung in Echtzeit: Wir erfassen, analysieren und visualisieren Daten sofort, um schnelle und effektive Entscheidungen zu ermöglichen.",
              "Kostenreduzierung: Wir verbessern die Betriebseffizienz und reduzieren Abfall, Energieverbrauch und Unterbrechungen.",
              "Vorausschauende Wartung: Wir erkennen Ausfallmuster, bevor sie auftreten, verlängern die Lebensdauer Ihrer Geräte und reduzieren Ausfallzeiten.",
              "Ständige technologische Anpassung: Unsere Lösungen sind darauf ausgelegt, mit Ihrer Anlage zu wachsen und sich neuen Technologien anzupassen.",
              "Modulare und nicht-invasive Strategie: Wir digitalisieren, ohne bestehende Prozesse zu unterbrechen, respektieren die aktuelle Architektur und ermöglichen schrittweise Verbesserungen."
            ]
          },
          paraQuien: {
            description: `Dieser Service richtet sich an Industrieunternehmen, die ihre Abläufe in intelligente, widerstandsfähige und datengesteuerte Anlagen verwandeln möchten. Ideale Profile sind:`,
            perfiles: [
              "Getränke-, Fermentations- und Destillationsanlagen: Brauereien, Mälzereien oder Tequileras, die die Überwachung kritischer Variablen, Chargenrückverfolgbarkeit, Energieeffizienz und Echtzeit-Verlustkontrolle suchen.",
              "Flüssige oder Schüttgut-Lebensmittelindustrie: Produzenten wie Sucroliq, die mehrere Anlagen betreiben und Fernkonnektivität, zentrale Visualisierung, Prozesskontrolle und vorausschauende Wartung benötigen.",
              "Betriebe mit moderner Infrastruktur, die den nächsten Schritt machen möchten: Unternehmen, die bereits über Siemens-SPS, PCS7- oder TIA-Portal-Systeme verfügen und Visualisierung, KI oder prädiktive Analytik zur Produktivitätssteigerung einführen möchten.",
              "Wachsende Unternehmen oder solche mit Modernisierungsplänen: Unternehmen, die expandieren oder ihre Abläufe diversifizieren und eine strukturierte Digitalisierungsstrategie benötigen, die ihre bestehende Architektur respektiert.",
              "Unternehmen mit Fokus auf operative Nachhaltigkeit: Anlagen, die den Energie-, Wasser- oder Rohstoffverbrauch durch intelligente Nutzung von Prozessdaten senken möchten."
            ]
          }
        }
      ],
      banner: {
        image: new URL('@/assets/images/servicios_banner.png', import.meta.url).href,
        content: `Passt Ihr Unternehmen nicht genau zu diesen Profilen?
Bei Frenkel verstehen wir, dass jeder industrielle Betrieb einzigartige Herausforderungen und Chancen hat. Wenn Ihr Unternehmen nicht zu den genannten Branchen gehört, machen Sie sich keine Sorgen! Unser Ansatz ist flexibel, und wir passen unsere Lösungen an verschiedene Branchen an, die ihre Prozesse durch Digitalisierung, Datenanalyse und Automatisierung optimieren möchten.
Kontaktieren Sie uns und erfahren Sie, wie wir Ihnen helfen können, Ihren Betrieb auf die nächste Stufe zu heben – unabhängig von Branche oder Unternehmensgröße.`
      },
      cta: {
        title: "Bereit zu starten?",
        content: "Planen Sie Ihr Projekt auf solider Basis. Kontaktieren Sie uns und vereinbaren Sie einen Termin mit unseren Technikexperten, um den ersten Schritt zu einer intelligenteren und effizienteren Betriebsführung zu machen.",
        button: "Senden"
      }
    }
  }
},

 'automatizacion-de-control': {
  slugs: {
    es: '/automatizacion-de-control',
    en: '/automatizacion-de-control',
    de: '/automatizacion-de-control'
  },
  category: {
    es: 'Automatización Industrial',
    en: 'Industrial Automation',
    de: 'Industrielle Automatisierung'
  },
  images: {
    icon: new URL('@/assets/images/servicio02.svg', import.meta.url).href,
    iconHover: new URL('@/assets/images/servicio02-hover.svg', import.meta.url).href,
    hero: {
      es: new URL('@/assets/images/hero_automatizacion.png', import.meta.url).href,
      en: new URL('@/assets/images/hero_automatizacion.png', import.meta.url).href,
      de: new URL('@/assets/images/hero_automatizacion.png', import.meta.url).href
    },
    detalle: {
      es: new URL('@/assets/images/automatizacion_servicios.png', import.meta.url).href,
      en: new URL('@/assets/images/automatizacion_servicios.png', import.meta.url).href,
      de: new URL('@/assets/images/automatizacion_servicios.png', import.meta.url).href
    },
    banner: {
      es: new URL('@/assets/images/servicios_banner.png', import.meta.url).href,
      en: new URL('@/assets/images/servicios_banner.png', import.meta.url).href,
      de: new URL('@/assets/images/servicios_banner.png', import.meta.url).href
    }
  },
 titles: {
  es: 'Automatización y Control',
  en: 'Automation and Control',
  de: 'Automatisierung und Regelungstechnik'
},
descriptions: {
  es: 'Servicios y soluciones para impulsar la eficiencia, la calidad y el crecimiento: consultoría, implementación y soporte integral.',
  en: 'Services and solutions to drive efficiency, quality, and growth—consulting, implementation, and end-to-end support.',
  de: 'Dienstleistungen und Lösungen für mehr Effizienz, Qualität und Wachstum – Beratung, Implementierung und End-to-End-Support.'
},
  expertise: {
    es: 'Desde la integración de sistemas SCADA y PLC hasta la automatización avanzada de procesos, optimizamos cada etapa de tu operación.',
    en: 'From SCADA and PLC system integration to advanced process automation, we optimize every stage of your operation.',
    de: 'Von der Integration von SCADA- und SPS-Systemen bis hin zur fortschrittlichen Prozessautomatisierung optimieren wir jede Phase Ihres Betriebs.'
  },
  detail: {
    es: {
      hero: {
        title: "Automatización y Control",
        image: new URL('@/assets/images/hero_automatizacion.png', import.meta.url).href
      },
      tabs: [
        {
          title: "Automatización y Control",
          image: new URL('@/assets/images/automatizacion_servicios.png', import.meta.url).href,
          index: [
            { label: "Introducción", anchor: "introduccion" },
            { label: "Qué incluye el servicio", anchor: "incluye" },
            { label: "Ventajas", anchor: "ventajas" },
            { label: "Para quién", anchor: "para-quien" }
          ],
          introduccion: {
            content: `
En Frenkel desarrollamos soluciones avanzadas de Automatización de Control diseñadas para maximizar la eficiencia, confiabilidad y seguridad operativa en entornos industriales complejos. Nuestra experiencia en el diseño, programación y puesta en marcha de sistemas SCADA, PLC y control de procesos nos permite ofrecer una automatización efectiva, escalable y adaptada a cada operación.
Integramos hardware y software industrial de marcas líderes (como Siemens y Rockwell) con prácticas modernas de ingeniería de control, garantizando resultados sólidos y sostenibles para la planta.
            `.trim()
          },
          incluye: {
            description: `
Nuestro servicio cubre todo el ciclo de vida de los sistemas de automatización, desde la ingeniería conceptual hasta el soporte post-implementación. Las áreas clave incluyen:
            `.trim(),
            items: [
              {
                title: "Diseño e implementación de sistemas SCADA",
                content: "Creamos arquitecturas de supervisión robustas, con interfaces amigables y conectividad a múltiples dispositivos y áreas de proceso."
              },
              {
                title: "Programación y puesta en marcha de PLCs",
                content: "Desarrollamos lógica de control para plataformas como Siemens (TIA Portal, PCS7, S7-1500) y Rockwell, aplicando estándares de codificación y pruebas FAT/SAT."
              },
              {
                title: "Automatización de procesos industriales",
                content: "Controlamos variables críticas y secuencias automáticas para líneas de producción, fermentación, envasado, cocimiento, pasteurización y más."
              },
              {
                title: "Monitoreo y operación remota",
                content: "Implementamos comunicación industrial segura y acceso remoto (OPC UA, VPN, edge devices), para facilitar el diagnóstico, control y toma de decisiones desde cualquier lugar."
              }
            ]
          },
          ventajas: {
            items: [
              "Mayor productividad: Automatizamos tareas repetitivas, reducimos tiempos de ciclo y aumentamos el rendimiento general de la operación.",
              "Reducción de errores y paros: Disminuimos la intervención humana y diseñamos sistemas tolerantes a fallos que previenen errores operativos y mejoran la disponibilidad.",
              "Uso eficiente de recursos: Optimizamos el consumo energético y de insumos mediante control de precisión y regulación inteligente.",
              "Escalabilidad y modularidad: Nuestras soluciones están diseñadas para crecer junto con tu planta, integrando nuevos equipos o procesos sin necesidad de rediseñar todo el sistema."
            ]
          },
          paraQuien: {
            description: `Este servicio está dirigido a empresas en sectores como:`,
            perfiles: [
              "Manufactura: Optimización de líneas de producción y automatización de tareas repetitivas.",
              "Energía: Automatización de la gestión de redes eléctricas y sistemas de control de plantas energéticas.",
              "Alimentos y bebidas: Automatización de las líneas de envasado y control de calidad.",
              "Automotriz: Implementación de sistemas automatizados de ensamblaje y control de calidad en procesos de fabricación.",
              "Bebidas, fermentación y destilados: Cervecerías, malterías y tequileras que buscan controlar variables críticas como temperatura, presión, tiempos de fermentación o calidad del producto, integrando SCADA y PLC en sistemas modulares.",
              "Agroindustria líquida y plantas de procesos continuos: Empresas que requieren estandarizar la operación entre plantas, visualizar datos de forma centralizada y reducir variabilidad mediante automatización precisa.",
              "Alimentos y bebidas en general: Líneas de envasado, pasteurización, cocción o mezcla que se benefician de automatización robusta con trazabilidad y control de calidad embebido.",
              "Industrias en expansión o modernización: Operaciones con infraestructura mixta (equipos modernos + sistemas legados) que desean integrar nuevos equipos o líneas sin frenar la producción, usando un enfoque modular y no invasivo."
            ]
          }
        }
      ],
      banner: {
        image: new URL('@/assets/images/servicios_banner.png', import.meta.url).href,
        content: `¿Tu empresa no encaja exactamente en estos perfiles?
En Frenkel, entendemos que cada operación industrial tiene retos y oportunidades únicos. Si tu empresa no se encuentra dentro de los rubros mencionados, ¡no te preocupes! Nuestro enfoque es flexible y adaptamos nuestras soluciones a diferentes sectores que buscan optimizar sus procesos a través de la digitalización, el análisis de datos y la automatización.
Contáctanos y descubre cómo podemos ayudarte a llevar tu operación al siguiente nivel, sin importar el giro o tamaño de tu negocio.`
      },
      cta: {
        title: "¿Listos para comenzar?",
        content: "Diseña tu proyecto con bases sólidas. Contáctanos y agenda una sesión con nuestros expertos en ingeniería para dar el primer paso hacia una operación más inteligente y eficiente.",
        button: "Enviar"
      }
    },
    en: {
      hero: {
        title: "Automation & Control",
        image: new URL('@/assets/images/hero_automatizacion.png', import.meta.url).href
      },
      tabs: [
        {
          title: "Automation & Control",
          image: new URL('@/assets/images/automatizacion_servicios.png', import.meta.url).href,
          index: [
            { label: "Introduction", anchor: "introduccion" },
            { label: "What the service includes", anchor: "incluye" },
            { label: "Advantages", anchor: "ventajas" },
            { label: "Who is it for", anchor: "para-quien" }
          ],
          introduccion: {
            content: `
At Frenkel, we develop advanced Automation and Control solutions designed to maximize efficiency, reliability, and operational safety in complex industrial environments. Our experience in designing, programming, and commissioning SCADA, PLC, and process control systems allows us to offer effective, scalable, and customized automation for each operation.
We integrate industrial hardware and software from leading brands (such as Siemens and Rockwell) with modern control engineering practices, ensuring solid and sustainable results for your plant.
            `.trim()
          },
          incluye: {
            description: `
Our service covers the entire lifecycle of automation systems, from conceptual engineering to post-implementation support. Key areas include:
            `.trim(),
            items: [
              {
                title: "SCADA System Design and Implementation",
                content: "We create robust supervisory architectures, with user-friendly interfaces and connectivity to multiple devices and process areas."
              },
              {
                title: "PLC Programming and Commissioning",
                content: "We develop control logic for platforms such as Siemens (TIA Portal, PCS7, S7-1500) and Rockwell, applying coding standards and FAT/SAT testing."
              },
              {
                title: "Industrial Process Automation",
                content: "We control critical variables and automatic sequences for production lines, fermentation, packaging, cooking, pasteurization, and more."
              },
              {
                title: "Remote Monitoring and Operation",
                content: "We implement secure industrial communication and remote access (OPC UA, VPN, edge devices), making it easy to diagnose, control, and make decisions from anywhere."
              }
            ]
          },
          ventajas: {
            items: [
              "Greater productivity: We automate repetitive tasks, reduce cycle times, and increase the overall performance of the operation.",
              "Error and downtime reduction: We minimize human intervention and design fault-tolerant systems that prevent operational errors and improve availability.",
              "Efficient resource use: We optimize energy and input consumption through precision control and intelligent regulation.",
              "Scalability and modularity: Our solutions are designed to grow with your plant, integrating new equipment or processes without the need to redesign the entire system."
            ]
          },
          paraQuien: {
            description: `This service is aimed at companies in sectors such as:`,
            perfiles: [
              "Manufacturing: Optimization of production lines and automation of repetitive tasks.",
              "Energy: Automation of electrical grid management and control systems for energy plants.",
              "Food and beverages: Automation of packaging lines and quality control.",
              "Automotive: Implementation of automated assembly and quality control systems in manufacturing processes.",
              "Beverages, fermentation, and distillation: Breweries, malt houses, and tequila producers seeking to control critical variables such as temperature, pressure, fermentation times, or product quality, integrating SCADA and PLC in modular systems.",
              "Liquid agribusiness and continuous process plants: Companies needing to standardize operations between plants, centralize data visualization, and reduce variability through precise automation.",
              "General food and beverage: Packaging, pasteurization, cooking, or mixing lines benefiting from robust automation with traceability and embedded quality control.",
              "Expanding or modernizing industries: Operations with mixed infrastructure (modern equipment + legacy systems) looking to integrate new equipment or lines without halting production, using a modular and non-invasive approach."
            ]
          }
        }
      ],
      banner: {
        image: new URL('@/assets/images/servicios_banner.png', import.meta.url).href,
        content: `Does your company not fit exactly into these profiles?
At Frenkel, we understand that every industrial operation has unique challenges and opportunities. If your company is not within the mentioned sectors, don't worry! Our approach is flexible and we adapt our solutions to different sectors seeking to optimize their processes through digitalization, data analysis, and automation.
Contact us and discover how we can help take your operation to the next level, regardless of your business's size or field.`
      },
      cta: {
        title: "Ready to get started?",
        content: "Design your project on solid foundations. Contact us and schedule a session with our engineering experts to take the first step toward a smarter and more efficient operation.",
        button: "Send"
      }
    },
    de: {
      hero: {
        title: "Automatisierung & Steuerung",
        image: new URL('@/assets/images/hero_automatizacion.png', import.meta.url).href
      },
      tabs: [
        {
          title: "Automatisierung & Steuerung",
          image: new URL('@/assets/images/automatizacion_servicios.png', import.meta.url).href,
          index: [
            { label: "Einführung", anchor: "introduccion" },
            { label: "Was der Service beinhaltet", anchor: "incluye" },
            { label: "Vorteile", anchor: "ventajas" },
            { label: "Für wen", anchor: "para-quien" }
          ],
          introduccion: {
            content: `
Bei Frenkel entwickeln wir fortschrittliche Automatisierungs- und Steuerungslösungen, die darauf ausgelegt sind, Effizienz, Zuverlässigkeit und Betriebssicherheit in komplexen Industrieumgebungen zu maximieren. Unsere Erfahrung im Design, in der Programmierung und Inbetriebnahme von SCADA-, SPS- und Prozessleitsystemen ermöglicht es uns, effektive, skalierbare und maßgeschneiderte Automatisierungslösungen für jeden Betrieb anzubieten.
Wir integrieren industrielle Hardware und Software von führenden Marken (wie Siemens und Rockwell) mit modernen Steuerungstechniken und gewährleisten solide und nachhaltige Ergebnisse für Ihre Anlage.
            `.trim()
          },
          incluye: {
            description: `
Unser Service deckt den gesamten Lebenszyklus von Automatisierungssystemen ab, von der Konzeptentwicklung bis zum Support nach der Implementierung. Zentrale Bereiche sind:
            `.trim(),
            items: [
              {
                title: "Design und Implementierung von SCADA-Systemen",
                content: "Wir schaffen robuste Überwachungsarchitekturen mit benutzerfreundlichen Schnittstellen und Konnektivität zu mehreren Geräten und Prozessbereichen."
              },
              {
                title: "SPS-Programmierung und Inbetriebnahme",
                content: "Wir entwickeln Steuerungslogik für Plattformen wie Siemens (TIA Portal, PCS7, S7-1500) und Rockwell, wenden Codierungsstandards an und führen FAT/SAT-Tests durch."
              },
              {
                title: "Industrielle Prozessautomatisierung",
                content: "Wir steuern kritische Variablen und automatische Sequenzen für Produktionslinien, Fermentation, Verpackung, Kochen, Pasteurisierung und mehr."
              },
              {
                title: "Fernüberwachung und -betrieb",
                content: "Wir implementieren sichere industrielle Kommunikation und Fernzugriff (OPC UA, VPN, Edge Devices), um Diagnose, Steuerung und Entscheidungsfindung von überall zu erleichtern."
              }
            ]
          },
          ventajas: {
            items: [
              "Höhere Produktivität: Wir automatisieren sich wiederholende Aufgaben, verkürzen Zykluszeiten und steigern die Gesamtleistung des Betriebs.",
              "Reduzierung von Fehlern und Ausfallzeiten: Wir minimieren den menschlichen Eingriff und entwickeln fehlertolerante Systeme, die Betriebsfehler verhindern und die Verfügbarkeit verbessern.",
              "Effizienter Ressourceneinsatz: Wir optimieren den Energie- und Materialverbrauch durch Präzisionssteuerung und intelligente Regelung.",
              "Skalierbarkeit und Modularität: Unsere Lösungen sind darauf ausgelegt, mit Ihrer Anlage zu wachsen und neue Geräte oder Prozesse zu integrieren, ohne das gesamte System neu zu gestalten."
            ]
          },
          paraQuien: {
            description: `Dieser Service richtet sich an Unternehmen in Sektoren wie:`,
            perfiles: [
              "Fertigung: Optimierung von Produktionslinien und Automatisierung wiederkehrender Aufgaben.",
              "Energie: Automatisierung des Managements von Stromnetzen und Steuerungssystemen für Energieanlagen.",
              "Lebensmittel und Getränke: Automatisierung von Verpackungslinien und Qualitätskontrolle.",
              "Automobilindustrie: Implementierung automatisierter Montage- und Qualitätskontrollsysteme in Produktionsprozessen.",
              "Getränke, Fermentation und Destillation: Brauereien, Mälzereien und Tequila-Hersteller, die kritische Variablen wie Temperatur, Druck, Gärzeiten oder Produktqualität steuern und SCADA und SPS in modulare Systeme integrieren möchten.",
              "Flüssige Agrarindustrie und kontinuierliche Prozessanlagen: Unternehmen, die den Betrieb zwischen Anlagen standardisieren, die Datenvisualisierung zentralisieren und die Variabilität durch präzise Automatisierung reduzieren müssen.",
              "Allgemeine Lebensmittel und Getränke: Verpackungs-, Pasteurisierungs-, Koch- oder Mischlinien, die von robuster Automatisierung mit Rückverfolgbarkeit und eingebauter Qualitätskontrolle profitieren.",
              "Wachsende oder modernisierende Industrien: Betriebe mit gemischter Infrastruktur (moderne Ausrüstung + Altsysteme), die neue Ausrüstung oder Linien integrieren möchten, ohne die Produktion zu stoppen, mit einem modularen und nicht-invasiven Ansatz."
            ]
          }
        }
      ],
      banner: {
        image: new URL('@/assets/images/servicios_banner.png', import.meta.url).href,
        content: `Passt Ihr Unternehmen nicht genau zu diesen Profilen?
Bei Frenkel verstehen wir, dass jeder industrielle Betrieb einzigartige Herausforderungen und Chancen hat. Wenn Ihr Unternehmen nicht zu den genannten Branchen gehört, machen Sie sich keine Sorgen! Unser Ansatz ist flexibel, und wir passen unsere Lösungen an verschiedene Branchen an, die ihre Prozesse durch Digitalisierung, Datenanalyse und Automatisierung optimieren möchten.
Kontaktieren Sie uns und erfahren Sie, wie wir Ihnen helfen können, Ihren Betrieb auf die nächste Stufe zu heben – unabhängig von Branche oder Unternehmensgröße.`
      },
      cta: {
        title: "Bereit zu starten?",
        content: "Planen Sie Ihr Projekt auf solider Basis. Kontaktieren Sie uns und vereinbaren Sie einen Termin mit unseren Technikexperten, um den ersten Schritt zu einer intelligenteren und effizienteren Betriebsführung zu machen.",
        button: "Senden"
      }
    }
  }
}

,

//CONSULTORIA
consultoria: {
  slugs: {
    es: '/consultoria-asesoria-ingenieria',
    en: '/consultoria-asesoria-ingenieria',
    de: '/consultoria-asesoria-ingenieria'
  },
  category: {
    es: 'Consultoría',
    en: 'Consulting',
    de: 'Beratung'
  },
  images: {
    icon: new URL('@/assets/images/servicio03.svg', import.meta.url).href,
    iconHover: new URL('@/assets/images/servicio03-hover.svg', import.meta.url).href,
    hero: {
      es: new URL('@/assets/images/hero_capacitacion_industria.png', import.meta.url).href,
      en: new URL('@/assets/images/hero_capacitacion_industria.png', import.meta.url).href,
      de: new URL('@/assets/images/hero_capacitacion_industria.png', import.meta.url).href
    },
    detalle: {
      es: [
        new URL('@/assets/images/servicios_capacitacion_consultoria.png', import.meta.url).href,
        new URL('@/assets/images/servicios_capacitacion_industria.png', import.meta.url).href,
        new URL('@/assets/images/servicios_capacitacion_proyectos.png', import.meta.url).href
      ],
      en: [
        new URL('@/assets/images/servicios_capacitacion_consultoria.png', import.meta.url).href,
        new URL('@/assets/images/servicios_capacitacion_industria.png', import.meta.url).href,
        new URL('@/assets/images/servicios_capacitacion_proyectos.png', import.meta.url).href
      ],
      de: [
        new URL('@/assets/images/servicios_capacitacion_consultoria.png', import.meta.url).href,
        new URL('@/assets/images/servicios_capacitacion_industria.png', import.meta.url).href,
        new URL('@/assets/images/servicios_capacitacion_proyectos.png', import.meta.url).href
      ]
    },
    banner: {
      es: new URL('@/assets/images/servicios_banner.png', import.meta.url).href,
      en: new URL('@/assets/images/servicios_banner.png', import.meta.url).href,
      de: new URL('@/assets/images/servicios_banner.png', import.meta.url).href
    }
  },
  titles: {
    es: 'Consultoría y Asesoría',
    en: 'Consulting & Advisory',
    de: 'Beratung & Consulting'
  },
  descriptions: {
    es: 'Brindamos consultoría y asesoría especializada en automatización, control, proyectos industriales e Industria 4.0, para optimizar la operación y la toma de decisiones.',
    en: 'We provide specialized consulting and advisory in automation, control, industrial projects, and Industry 4.0 to optimize operations and decision-making.',
    de: 'Wir bieten spezialisierte Beratung und Consulting in den Bereichen Automatisierung, Steuerung, Industrieprojekte und Industrie 4.0 zur Optimierung von Betrieb und Entscheidungsfindung.'
  },
  expertise: {
    es: 'Evaluamos, diseñamos e implementamos estrategias de mejora en procesos industriales, gestión de proyectos y transformación digital.',
    en: 'We assess, design, and implement improvement strategies in industrial processes, project management, and digital transformation.',
    de: 'Wir bewerten, entwerfen und implementieren Verbesserungsstrategien in industriellen Prozessen, Projektmanagement und digitaler Transformation.'
  },
  detail: {
    es: {
      hero: {
        title: "Consultoría y Asesoría de Ingeniería",
        image: new URL('@/assets/images/hero_capacitacion_industria.png', import.meta.url).href
      },
      tabs: [
        {
          title: "Automatización, Control e Instrumentación",
          image: new URL('@/assets/images/servicios_capacitacion_consultoria.png', import.meta.url).href,
          index: [
            { label: "Introducción", anchor: "introduccion" },
            { label: "Qué incluye el servicio", anchor: "incluye" },
            { label: "Ventajas", anchor: "ventajas" },
            { label: "Para quién", anchor: "para-quien" }
          ],
          introduccion: {
            content: `En Frenkel, ofrecemos Consultoría y Asesoría en Automatización, Control e Instrumentación, ayudando a las empresas a identificar oportunidades para optimizar sus procesos industriales a través de la automatización y el control avanzado. A través de nuestra experiencia y conocimiento profundo de la industria, guiamos a nuestros clientes en la implementación de sistemas que mejoran la eficiencia operativa, la fiabilidad de los equipos y la seguridad en la planta.`
          },
          incluye: {
            description: `Nuestra consultoría en Automatización, Control e Instrumentación está orientada a diseñar estrategias personalizadas que permiten a las empresas automatizar procesos, optimizar el control de sus sistemas y monitorear las variables clave. Ofrecemos:`,
            items: [
              { title: "Evaluación de procesos", content: "Análisis detallado de los sistemas de control e instrumentación actuales para identificar áreas de mejora." },
              { title: "Recomendaciones tecnológicas", content: "Asesoramos sobre las mejores tecnologías y soluciones para optimizar el rendimiento de las operaciones industriales." },
              { title: "Diseño de sistemas de control", content: "Orientamos sobre el diseño e integración de sistemas SCADA, PLC y dispositivos de instrumentación para el monitoreo en tiempo real." },
              { title: "Implementación y mantenimiento", content: "Brindamos guía sobre la implementación de sistemas automatizados y su posterior mantenimiento para garantizar un rendimiento óptimo." }
            ]
          },
          ventajas: {
            items: [
              "Mejora en la eficiencia: Identificamos las mejores soluciones tecnológicas para aumentar la productividad y reducir costos.",
              "Optimización del control: Mejoramos los sistemas de monitoreo y control, garantizando operaciones más seguras y fiables.",
              "Reducción de errores humanos: La automatización permite reducir la intervención humana, minimizando fallos operativos y aumentando la precisión."
            ]
          },
          paraQuien: {
            description: `Este servicio está orientado a empresas industriales que buscan automatizar, estandarizar o mejorar el control de sus procesos operativos, tales como:`,
            perfiles: [
              "Plantas de alimentos, bebidas y fermentación: Industrias que requieren control preciso de variables críticas, integración de instrumentación inteligente y automatización de procesos para garantizar calidad, trazabilidad y eficiencia.",
              "Empresas agroindustriales líquidas: Organizaciones como Sucroliq que necesitan asesoría técnica para diseñar o mejorar la instrumentación de plantas remotas, con visualización remota, conectividad segura y estandarización de control.",
              "Industrias en expansión o con infraestructura mixta: Plantas que buscan renovar sus sistemas legados, modernizar arquitectura de control o integrar nuevos equipos a plataformas existentes sin frenar la operación.",
              "Clientes que operan bajo normativas de calidad estrictas: Empresas que requieren garantizar validación de procesos mediante sensores calibrados, alarmas, redundancia y trazabilidad completa."
            ]
          }
        },
        {
          title: "Industria 4.0",
          image: new URL('@/assets/images/servicios_capacitacion_industria.png', import.meta.url).href,
          index: [
            { label: "Introducción", anchor: "introduccion" },
            { label: "Qué incluye el servicio", anchor: "incluye" },
            { label: "Ventajas", anchor: "ventajas" },
            { label: "Para quién", anchor: "para-quien" }
          ],
          introduccion: {
            content: `En Frenkel, brindamos Consultoría y Asesoría en Industria 4.0, ayudando a las empresas a transitar hacia la transformación digital. Guiamos a nuestros clientes en la implementación de soluciones avanzadas como el Internet Industrial de las Cosas (IIoT), Big Data y análisis predictivo, asegurando que puedan aprovechar al máximo las tecnologías emergentes para mejorar la eficiencia y la competitividad de sus operaciones.`
          },
          incluye: {
            description: `Nuestra consultoría en Industria 4.0 abarca la integración de tecnologías disruptivas para la digitalización de procesos industriales:`,
            items: [
              { title: "Evaluación de la madurez digital", content: "Analizamos el nivel de digitalización actual de la planta y definimos una hoja de ruta para la integración de soluciones 4.0." },
              { title: "Integración de IIoT", content: "Asesoramos en la selección e instalación de sensores y dispositivos inteligentes para la recolección de datos en tiempo real." },
              { title: "Análisis de Big Data", content: "Implementamos soluciones de análisis de datos para mejorar la toma de decisiones y la previsión de problemas." },
              { title: "Automatización avanzada", content: "Guiamos en la implementación de sistemas de automatización inteligente para mejorar el control y la eficiencia operativa." }
            ]
          },
          ventajas: {
            items: [
              "Transformación digital efectiva: Ayudamos a las empresas a dar el salto hacia la digitalización, integrando las tecnologías más avanzadas en sus procesos.",
              "Mejora de la eficiencia operativa: La automatización y el análisis de datos permiten una gestión más ágil y eficiente.",
              "Toma de decisiones informadas: Las soluciones de Big Data y análisis predictivo permiten decisiones más rápidas y fundamentadas.",
              "Preparación para el futuro: Preparamos a las empresas para los retos del futuro, asegurando que estén alineadas con las tendencias tecnológicas globales."
            ]
          },
          paraQuien: {
            description: `Este servicio está orientado a empresas que desean iniciar o escalar su proceso de transformación digital con una hoja de ruta clara y tecnologías bien seleccionadas. Sectores ideales incluyen:`,
            perfiles: [
              "Plantas de bebidas, fermentación y alimentos líquidos: Empresas que desean conectar sistemas existentes (PLCs, sensores, SCADA) con plataformas analíticas, control inteligente y mantenimiento predictivo, integrando tecnologías sin detener la operación.",
              "Tequileras y destilerías: Negocios que buscan digitalizar procesos de producción, trazabilidad por lote, consumo energético y control de calidad, con soluciones diseñadas para entornos exigentes y regulados.",
              "Malterías y cervecerías industriales: Operaciones con gran volumen de datos de proceso que necesitan conectividad, análisis visual e inteligencia operativa para optimizar la eficiencia y reducir desperdicio.",
              "Empresas con visión de sostenibilidad y eficiencia energética: Clientes que buscan medir, analizar y actuar sobre el consumo de recursos (agua, energía, vapor) en tiempo real, como parte de una estrategia integral de Industria 4.0."
            ]
          }
        },
        {
          title: "Manejo de Proyectos",
          image: new URL('@/assets/images/servicios_capacitacion_proyectos.png', import.meta.url).href,
          index: [
            { label: "Introducción", anchor: "introduccion" },
            { label: "Qué incluye el servicio", anchor: "incluye" },
            { label: "Ventajas", anchor: "ventajas" },
            { label: "Para quién", anchor: "para-quien" }
          ],
          introduccion: {
            content: `Frenkel ofrece Consultoría y Asesoría en Manejo de Proyectos, asegurando que cada fase de tus proyectos industriales se ejecute de manera eficiente y alineada con los objetivos estratégicos. Con nuestra experiencia en gestión de proyectos industriales, guiamos a nuestros clientes desde la planificación hasta la implementación y seguimiento, garantizando la entrega exitosa dentro de los plazos y presupuestos establecidos.`
          },
          incluye: {
            description: `Nuestro enfoque en Manejo de Proyectos se basa en ofrecer un servicio integral para el éxito de tus proyectos industriales:`,
            items: [
              { title: "Planificación estratégica", content: "Asesoramos en la elaboración de planes detallados, ajustados a las necesidades específicas de cada cliente." },
              { title: "Gestión de recursos", content: "Brindamos asesoría sobre la asignación eficiente de recursos humanos, materiales y financieros para garantizar el éxito del proyecto." },
              { title: "Control de ejecución", content: "Monitoreamos el progreso de los proyectos, asegurando que se cumplan los tiempos, costos y calidad especificados." },
              { title: "Cierre y entrega del proyecto", content: "Facilitamos la transición final del proyecto con una completa entrega de resultados, capacitación y soporte post-proyecto." }
            ]
          },
          ventajas: {
            items: [
              "Optimización de la ejecución: Nos aseguramos de que cada etapa se ejecute de manera eficiente, minimizando retrasos y costos adicionales.",
              "Cumplimiento de objetivos: Guiamos el proyecto para cumplir con los objetivos establecidos, garantizando que se alineen con la visión estratégica del cliente.",
              "Gestión de riesgos: Identificamos y gestionamos los riesgos potenciales, asegurando que el proyecto continúe sin interrupciones."
            ]
          },
          paraQuien: {
            description: `Este servicio está dirigido a empresas que gestionan proyectos industriales complejos y necesitan asegurar cumplimiento técnico, financiero y de tiempo, tales como:`,
            perfiles: [
              "Industrias de bebidas, destilados y alimentos: Plantas en proceso de expansión, automatización o migración de tecnología, donde se requiere una dirección de proyecto especializada que entienda la operación y los sistemas OT involucrados.",
              "Empresas que implementan soluciones industriales 4.0: Negocios que desarrollan proyectos de integración de edge computing, IIoT, mantenimiento predictivo o digitalización y requieren acompañamiento desde el diseño hasta la puesta en marcha.",
              "Agroindustria líquida y sistemas distribuidos: Organizaciones con proyectos simultáneos en distintas ubicaciones que necesitan coordinación integral, gestión de cronogramas y control de recursos centralizados.",
              "Clientes que buscan gobernanza de proyectos industriales: Empresas que requieren asesoría para estructurar equipos, procesos de compra, seguimiento técnico y criterios de éxito claros desde la etapa de planeación."
            ]
          }
        }
      ],
      banner: {
        image: new URL('@/assets/images/servicios_banner.png', import.meta.url).href,
        content: `¿Tu empresa no encaja exactamente en estos perfiles?
En Frenkel, entendemos que cada operación industrial tiene retos y oportunidades únicos. Si tu empresa no se encuentra dentro de los rubros mencionados, ¡no te preocupes! Nuestro enfoque es flexible y adaptamos nuestras soluciones a diferentes sectores que buscan optimizar sus procesos a través de la digitalización, el análisis de datos y la automatización.
Contáctanos y descubre cómo podemos ayudarte a llevar tu operación al siguiente nivel, sin importar el giro o tamaño de tu negocio.`
      },
      cta: {
        title: "¿Listos para comenzar?",
        content: "Diseña tu proyecto con bases sólidas. Contáctanos y agenda una sesión con nuestros expertos en ingeniería para dar el primer paso hacia una operación más inteligente y eficiente.",
        button: "Enviar"
      }
    },
    en: {
      hero: {
        title: "Engineering Consulting & Advisory",
        image: new URL('@/assets/images/hero_capacitacion_industria.png', import.meta.url).href
      },
      tabs: [
        {
          title: "Automation, Control & Instrumentation",
          image: new URL('@/assets/images/servicios_capacitacion_consultoria.png', import.meta.url).href,
          index: [
            { label: "Introduction", anchor: "introduccion" },
            { label: "What the service includes", anchor: "incluye" },
            { label: "Advantages", anchor: "ventajas" },
            { label: "Who is it for", anchor: "para-quien" }
          ],
          introduccion: {
            content: `At Frenkel, we offer Consulting and Advisory in Automation, Control & Instrumentation, helping companies identify opportunities to optimize their industrial processes through advanced automation and control. With our experience and deep industry knowledge, we guide our clients in implementing systems that improve operational efficiency, equipment reliability, and plant safety.`
          },
          incluye: {
            description: `Our consulting in Automation, Control & Instrumentation is focused on designing personalized strategies that allow companies to automate processes, optimize their systems control, and monitor key variables. We offer:`,
            items: [
              { title: "Process assessment", content: "Detailed analysis of current control and instrumentation systems to identify areas for improvement." },
              { title: "Technological recommendations", content: "We advise on the best technologies and solutions to optimize the performance of industrial operations." },
              { title: "Control systems design", content: "We guide on the design and integration of SCADA systems, PLCs, and instrumentation devices for real-time monitoring." },
              { title: "Implementation and maintenance", content: "We provide guidance on the implementation of automated systems and subsequent maintenance to ensure optimal performance." }
            ]
          },
          ventajas: {
            items: [
              "Efficiency improvement: We identify the best technological solutions to increase productivity and reduce costs.",
              "Control optimization: We improve monitoring and control systems, ensuring safer and more reliable operations.",
              "Reduction of human errors: Automation reduces human intervention, minimizing operational errors and increasing precision."
            ]
          },
          paraQuien: {
            description: `This service is aimed at industrial companies seeking to automate, standardize, or improve the control of their operational processes, such as:`,
            perfiles: [
              "Food, beverage, and fermentation plants: Industries requiring precise control of critical variables, smart instrumentation integration, and process automation to ensure quality, traceability, and efficiency.",
              "Liquid agro-industrial companies: Organizations like Sucroliq that need technical advice to design or improve instrumentation of remote plants, with remote visualization, secure connectivity, and standardized control.",
              "Expanding industries or those with mixed infrastructure: Plants looking to renew legacy systems, modernize control architecture, or integrate new equipment into existing platforms without stopping operation.",
              "Clients under strict quality regulations: Companies that require process validation through calibrated sensors, alarms, redundancy, and full traceability."
            ]
          }
        },
        {
          title: "Industry 4.0",
          image: new URL('@/assets/images/servicios_capacitacion_industria.png', import.meta.url).href,
          index: [
            { label: "Introduction", anchor: "introduccion" },
            { label: "What the service includes", anchor: "incluye" },
            { label: "Advantages", anchor: "ventajas" },
            { label: "Who is it for", anchor: "para-quien" }
          ],
          introduccion: {
            content: `At Frenkel, we provide Consulting and Advisory in Industry 4.0, helping companies transition to digital transformation. We guide our clients in implementing advanced solutions such as IIoT, Big Data, and predictive analytics, ensuring they can make the most of emerging technologies to improve efficiency and competitiveness.`
          },
          incluye: {
            description: `Our consulting in Industry 4.0 covers the integration of disruptive technologies for the digitalization of industrial processes:`,
            items: [
              { title: "Digital maturity assessment", content: "We analyze the plant's current level of digitalization and define a roadmap for the integration of 4.0 solutions." },
              { title: "IIoT integration", content: "We advise on selecting and installing smart sensors and devices for real-time data collection." },
              { title: "Big Data analytics", content: "We implement data analysis solutions to improve decision-making and forecasting." },
              { title: "Advanced automation", content: "We guide the implementation of smart automation systems to improve control and operational efficiency." }
            ]
          },
          ventajas: {
            items: [
              "Effective digital transformation: We help companies leap into digitalization, integrating the most advanced technologies into their processes.",
              "Improved operational efficiency: Automation and data analytics allow for more agile and efficient management.",
              "Informed decision-making: Big Data and predictive analytics enable faster and more well-founded decisions.",
              "Future readiness: We prepare companies for future challenges, ensuring they align with global technology trends."
            ]
          },
          paraQuien: {
            description: `This service is aimed at companies that want to start or scale their digital transformation with a clear roadmap and well-selected technologies. Ideal sectors include:`,
            perfiles: [
              "Beverage, fermentation, and liquid food plants: Companies seeking to connect existing systems (PLCs, sensors, SCADA) with analytics platforms, smart control, and predictive maintenance, integrating technologies without halting operations.",
              "Tequila producers and distilleries: Businesses seeking to digitize production processes, batch traceability, energy consumption, and quality control, with solutions designed for demanding and regulated environments.",
              "Industrial malt houses and breweries: Operations with large amounts of process data needing connectivity, visual analysis, and operational intelligence to optimize efficiency and reduce waste.",
              "Companies with a vision for sustainability and energy efficiency: Clients seeking to measure, analyze, and act on resource consumption (water, energy, steam) in real time as part of a comprehensive Industry 4.0 strategy."
            ]
          }
        },
        {
          title: "Project Management",
          image: new URL('@/assets/images/servicios_capacitacion_proyectos.png', import.meta.url).href,
          index: [
            { label: "Introduction", anchor: "introduccion" },
            { label: "What the service includes", anchor: "incluye" },
            { label: "Advantages", anchor: "ventajas" },
            { label: "Who is it for", anchor: "para-quien" }
          ],
          introduccion: {
            content: `Frenkel offers Project Management Consulting and Advisory, ensuring that every phase of your industrial projects is executed efficiently and aligned with strategic objectives. With our experience in managing industrial projects, we guide our clients from planning to implementation and follow-up, guaranteeing successful delivery within set deadlines and budgets.`
          },
          incluye: {
            description: `Our approach to Project Management is based on providing a comprehensive service for the success of your industrial projects:`,
            items: [
              { title: "Strategic planning", content: "We advise on the development of detailed plans, tailored to each client's specific needs." },
              { title: "Resource management", content: "We advise on the efficient allocation of human, material, and financial resources to ensure project success." },
              { title: "Execution control", content: "We monitor project progress, ensuring compliance with specified timelines, costs, and quality." },
              { title: "Project closure and delivery", content: "We facilitate the final project transition with complete results delivery, training, and post-project support." }
            ]
          },
          ventajas: {
            items: [
              "Execution optimization: We ensure each stage is carried out efficiently, minimizing delays and additional costs.",
              "Objective fulfillment: We guide the project to meet established objectives, ensuring alignment with the client's strategic vision.",
              "Risk management: We identify and manage potential risks, ensuring the project continues without interruptions."
            ]
          },
          paraQuien: {
            description: `This service is aimed at companies managing complex industrial projects and needing to ensure technical, financial, and timeline compliance, such as:`,
            perfiles: [
              "Beverage, distillation, and food industries: Plants undergoing expansion, automation, or technology migration, requiring specialized project management that understands operation and OT systems.",
              "Companies implementing industrial 4.0 solutions: Businesses developing integration projects for edge computing, IIoT, predictive maintenance, or digitalization, needing support from design to commissioning.",
              "Liquid agro-industry and distributed systems: Organizations with simultaneous projects in different locations needing integrated coordination, schedule management, and centralized resource control.",
              "Clients seeking industrial project governance: Companies needing advice to structure teams, procurement processes, technical monitoring, and clear success criteria from the planning stage."
            ]
          }
        }
      ],
      banner: {
        image: new URL('@/assets/images/servicios_banner.png', import.meta.url).href,
        content: `Does your company not fit exactly into these profiles?
At Frenkel, we understand that every industrial operation has unique challenges and opportunities. If your company is not within the mentioned sectors, don't worry! Our approach is flexible and we adapt our solutions to different sectors seeking to optimize their processes through digitalization, data analysis, and automation.
Contact us and discover how we can help take your operation to the next level, regardless of your business's size or field.`
      },
      cta: {
        title: "Ready to get started?",
        content: "Design your project on solid foundations. Contact us and schedule a session with our engineering experts to take the first step toward a smarter and more efficient operation.",
        button: "Send"
      }
    },
    de: {
      hero: {
        title: "Ingenieurberatung & Consulting",
        image: new URL('@/assets/images/hero_capacitacion_industria.png', import.meta.url).href
      },
      tabs: [
        {
          title: "Automatisierung, Steuerung & Instrumentierung",
          image: new URL('@/assets/images/servicios_capacitacion_consultoria.png', import.meta.url).href,
          index: [
            { label: "Einführung", anchor: "introduccion" },
            { label: "Was der Service beinhaltet", anchor: "incluye" },
            { label: "Vorteile", anchor: "ventajas" },
            { label: "Für wen", anchor: "para-quien" }
          ],
          introduccion: {
            content: `Bei Frenkel bieten wir Beratung und Unterstützung in den Bereichen Automatisierung, Steuerung und Instrumentierung an und helfen Unternehmen, Chancen zur Optimierung ihrer industriellen Prozesse durch fortschrittliche Automatisierung und Steuerung zu erkennen. Mit unserer Erfahrung und unserem tiefen Branchenwissen begleiten wir unsere Kunden bei der Implementierung von Systemen, die die operative Effizienz, die Zuverlässigkeit der Anlagen und die Sicherheit in der Anlage verbessern.`
          },
          incluye: {
            description: `Unsere Beratung konzentriert sich auf die Entwicklung maßgeschneiderter Strategien, die es Unternehmen ermöglichen, Prozesse zu automatisieren, ihre Steuersysteme zu optimieren und Schlüsselfaktoren zu überwachen. Wir bieten:`,
            items: [
              { title: "Prozessbewertung", content: "Detaillierte Analyse der aktuellen Steuerungs- und Instrumentierungssysteme zur Identifizierung von Verbesserungsmöglichkeiten." },
              { title: "Technologische Empfehlungen", content: "Wir beraten zu den besten Technologien und Lösungen zur Optimierung der industriellen Leistung." },
              { title: "Entwurf von Steuersystemen", content: "Wir beraten bei der Planung und Integration von SCADA-Systemen, SPS und Messgeräten für die Echtzeitüberwachung." },
              { title: "Implementierung und Wartung", content: "Wir begleiten die Implementierung automatisierter Systeme und deren anschließende Wartung für optimale Leistung." }
            ]
          },
          ventajas: {
            items: [
              "Effizienzsteigerung: Wir identifizieren die besten technologischen Lösungen, um die Produktivität zu steigern und Kosten zu senken.",
              "Optimierung der Steuerung: Wir verbessern Überwachungs- und Steuersysteme, um sicherere und zuverlässigere Abläufe zu gewährleisten.",
              "Reduzierung menschlicher Fehler: Die Automatisierung reduziert menschliches Eingreifen, minimiert Betriebsfehler und erhöht die Genauigkeit."
            ]
          },
          paraQuien: {
            description: `Dieser Service richtet sich an Industrieunternehmen, die ihre Prozesse automatisieren, standardisieren oder die Steuerung verbessern möchten, wie z.B.:`,
            perfiles: [
              "Lebensmittel-, Getränke- und Fermentationsanlagen: Branchen, die eine präzise Steuerung kritischer Variablen, die Integration intelligenter Instrumentierung und die Automatisierung von Prozessen benötigen, um Qualität, Rückverfolgbarkeit und Effizienz zu gewährleisten.",
              "Flüssige Agrarindustrie: Organisationen wie Sucroliq, die technische Beratung für die Auslegung oder Verbesserung der Instrumentierung in entfernten Anlagen benötigen, mit Fernvisualisierung, sicherer Konnektivität und standardisierter Steuerung.",
              "Wachsende oder gemischte Industrie: Anlagen, die Altsysteme erneuern, die Steuerungsarchitektur modernisieren oder neue Geräte in bestehende Plattformen integrieren möchten, ohne den Betrieb zu unterbrechen.",
              "Kunden unter strengen Qualitätsvorschriften: Unternehmen, die die Validierung von Prozessen durch kalibrierte Sensoren, Alarme, Redundanz und vollständige Rückverfolgbarkeit sicherstellen müssen."
            ]
          }
        },
        {
          title: "Industrie 4.0",
          image: new URL('@/assets/images/servicios_capacitacion_industria.png', import.meta.url).href,
          index: [
            { label: "Einführung", anchor: "introduccion" },
            { label: "Was der Service beinhaltet", anchor: "incluye" },
            { label: "Vorteile", anchor: "ventajas" },
            { label: "Für wen", anchor: "para-quien" }
          ],
          introduccion: {
            content: `Bei Frenkel bieten wir Beratung und Unterstützung im Bereich Industrie 4.0 und begleiten Unternehmen bei der digitalen Transformation. Wir begleiten unsere Kunden bei der Implementierung fortschrittlicher Lösungen wie IIoT, Big Data und Predictive Analytics, damit sie das Potenzial neuer Technologien zur Effizienz- und Wettbewerbssteigerung voll ausschöpfen können.`
          },
          incluye: {
            description: `Unsere Beratung in Industrie 4.0 umfasst die Integration disruptiver Technologien für die Digitalisierung industrieller Prozesse:`,
            items: [
              { title: "Bewertung der digitalen Reife", content: "Wir analysieren den aktuellen Digitalisierungsgrad der Anlage und definieren eine Roadmap für die Integration von 4.0-Lösungen." },
              { title: "Integration von IIoT", content: "Wir beraten bei der Auswahl und Installation intelligenter Sensoren und Geräte zur Echtzeit-Datenerfassung." },
              { title: "Big Data Analytics", content: "Wir implementieren Lösungen zur Datenanalyse, um Entscheidungsfindung und Prognosen zu verbessern." },
              { title: "Fortschrittliche Automatisierung", content: "Wir begleiten die Implementierung intelligenter Automatisierungssysteme zur Verbesserung der Steuerung und Effizienz." }
            ]
          },
          ventajas: {
            items: [
              "Effektive digitale Transformation: Wir helfen Unternehmen, den Sprung zur Digitalisierung zu schaffen, indem wir die fortschrittlichsten Technologien in ihre Prozesse integrieren.",
              "Verbesserung der operativen Effizienz: Automatisierung und Datenanalyse ermöglichen ein agileres und effizienteres Management.",
              "Fundierte Entscheidungen: Big Data und Predictive Analytics ermöglichen schnellere und fundiertere Entscheidungen.",
              "Zukunftssicherheit: Wir bereiten Unternehmen auf zukünftige Herausforderungen vor und sorgen dafür, dass sie mit globalen Technologietrends Schritt halten."
            ]
          },
          paraQuien: {
            description: `Dieser Service richtet sich an Unternehmen, die ihre digitale Transformation mit einer klaren Roadmap und ausgewählten Technologien starten oder skalieren möchten. Ideale Sektoren sind:`,
            perfiles: [
              "Getränke-, Fermentations- und Flüssiglebensmittelanlagen: Unternehmen, die bestehende Systeme (SPS, Sensoren, SCADA) mit Analyseplattformen, intelligenten Steuerungen und Predictive Maintenance verbinden möchten, ohne den Betrieb zu unterbrechen.",
              "Tequila- und Destillerieproduzenten: Unternehmen, die Produktionsprozesse, Chargenverfolgung, Energieverbrauch und Qualitätskontrolle digitalisieren möchten – mit Lösungen für anspruchsvolle und regulierte Umgebungen.",
              "Industrielle Mälzereien und Brauereien: Anlagen mit großen Mengen an Prozessdaten, die Konnektivität, visuelle Analysen und operative Intelligenz zur Effizienzsteigerung und Abfallreduzierung benötigen.",
              "Unternehmen mit Fokus auf Nachhaltigkeit und Energieeffizienz: Kunden, die den Verbrauch von Ressourcen (Wasser, Energie, Dampf) in Echtzeit messen, analysieren und optimieren möchten – als Teil einer umfassenden Industrie-4.0-Strategie."
            ]
          }
        },
        {
          title: "Projektmanagement",
          image: new URL('@/assets/images/servicios_capacitacion_proyectos.png', import.meta.url).href,
          index: [
            { label: "Einführung", anchor: "introduccion" },
            { label: "Was der Service beinhaltet", anchor: "incluye" },
            { label: "Vorteile", anchor: "ventajas" },
            { label: "Für wen", anchor: "para-quien" }
          ],
          introduccion: {
            content: `Frenkel bietet Beratung und Unterstützung im Projektmanagement, um sicherzustellen, dass jede Phase Ihrer Industrieprojekte effizient und strategisch ausgerichtet durchgeführt wird. Mit unserer Erfahrung im Management industrieller Projekte begleiten wir unsere Kunden von der Planung bis zur Umsetzung und Nachverfolgung, um eine erfolgreiche Lieferung innerhalb der gesetzten Fristen und Budgets zu gewährleisten.`
          },
          incluye: {
            description: `Unser Ansatz im Projektmanagement basiert darauf, einen umfassenden Service für den Erfolg Ihrer Industrieprojekte zu bieten:`,
            items: [
              { title: "Strategische Planung", content: "Wir beraten bei der Erstellung detaillierter Pläne, die auf die spezifischen Bedürfnisse jedes Kunden zugeschnitten sind." },
              { title: "Ressourcenmanagement", content: "Wir beraten bei der effizienten Zuteilung von Personal, Material und finanziellen Ressourcen für den Projekterfolg." },
              { title: "Ausführungskontrolle", content: "Wir überwachen den Projektfortschritt und stellen sicher, dass Zeitpläne, Kosten und Qualität eingehalten werden." },
              { title: "Projektabschluss und Übergabe", content: "Wir erleichtern die endgültige Projektübergabe mit vollständigen Ergebnissen, Schulungen und Support nach dem Projekt." }
            ]
          },
          ventajas: {
            items: [
              "Optimierung der Ausführung: Wir stellen sicher, dass jede Phase effizient durchgeführt wird, um Verzögerungen und zusätzliche Kosten zu minimieren.",
              "Erreichung der Ziele: Wir steuern das Projekt, um die festgelegten Ziele zu erreichen und die strategische Vision des Kunden sicherzustellen.",
              "Risikomanagement: Wir identifizieren und managen potenzielle Risiken, damit das Projekt ohne Unterbrechungen fortgesetzt werden kann."
            ]
          },
          paraQuien: {
            description: `Dieser Service richtet sich an Unternehmen, die komplexe Industrieprojekte managen und technische, finanzielle und zeitliche Vorgaben einhalten müssen, wie z.B.:`,
            perfiles: [
              "Getränke-, Destillations- und Lebensmittelindustrie: Anlagen in Expansion, Automatisierung oder Technologiemigration, die ein spezialisiertes Projektmanagement erfordern, das den Betrieb und OT-Systeme versteht.",
              "Unternehmen, die industrielle 4.0-Lösungen implementieren: Unternehmen, die Integrationsprojekte für Edge Computing, IIoT, vorausschauende Wartung oder Digitalisierung entwickeln und Unterstützung von der Planung bis zur Inbetriebnahme benötigen.",
              "Flüssige Agrarindustrie und verteilte Systeme: Organisationen mit gleichzeitigen Projekten an verschiedenen Standorten, die integrierte Koordination, Terminmanagement und zentrale Ressourcensteuerung benötigen.",
              "Kunden, die Governance für Industrieprojekte suchen: Unternehmen, die Beratung zur Teamstrukturierung, Beschaffungsprozessen, technischer Überwachung und klaren Erfolgskriterien ab der Planungsphase benötigen."
            ]
          }
        }
      ],
      banner: {
        image: new URL('@/assets/images/servicios_banner.png', import.meta.url).href,
        content: `Passt Ihr Unternehmen nicht genau zu diesen Profilen?
Bei Frenkel verstehen wir, dass jeder industrielle Betrieb einzigartige Herausforderungen und Chancen hat. Wenn Ihr Unternehmen nicht zu den genannten Branchen gehört, machen Sie sich keine Sorgen! Unser Ansatz ist flexibel, und wir passen unsere Lösungen an verschiedene Branchen an, die ihre Prozesse durch Digitalisierung, Datenanalyse und Automatisierung optimieren möchten.
Kontaktieren Sie uns und erfahren Sie, wie wir Ihnen helfen können, Ihren Betrieb auf die nächste Stufe zu heben – unabhängig von Branche oder Unternehmensgröße.`
      },
      cta: {
        title: "Bereit zu starten?",
        content: "Planen Sie Ihr Projekt auf solider Basis. Kontaktieren Sie uns und vereinbaren Sie einen Termin mit unseren Technikexperten, um den ersten Schritt zu einer intelligenteren und effizienteren Betriebsführung zu machen.",
        button: "Senden"
      }
    }
  }
}

}

//CASOS DE EXITO

export const simuladorSlides = {
  es: [
    {
      id: 1,
      titulo: "Casos de Éxito",
      texto:
        "Bienvenido al simulador de procesos industriales. Aquí podrás visualizar cómo nuestras soluciones inteligentes integran tecnología SCADA, análisis en Grafana e Inteligencia Artificial para optimizar la operación de una planta.",
      imagenFabrica: new URL("@/assets/images/simulador/fabrica.gif", import.meta.url).href,
      imagenScada: new URL("@/assets/images/simulador/scada_monitor.png", import.meta.url).href,
      animacion: null,
      botones: [{ texto: "Comenzar", accion: 2 }],
    },
    {
      id: 2,
      titulo: "SCADA",
      texto:
        "Un sistema SCADA (Supervisory Control and Data Acquisition) permite supervisar y controlar procesos industriales en tiempo real. A través de sensores, recopila datos de campo que luego se representan visualmente para la toma de decisiones.",
      imagen: new URL("@/assets/images/simulador/scada.png", import.meta.url).href,
      animacion: null,
      botones: [{ texto: "Iniciar proceso", accion: 3 }],
    },
    {
      id: 3,
      titulo: "Animación SCADA",
      texto:
        "En esta simulación, podrás observar cómo los datos recolectados por los sensores se procesan en el SCADA y se envían al sistema de análisis. Esto representa la fase de monitoreo automatizado de la planta.",
      imagen:
        "https://firebasestorage.googleapis.com/v0/b/frenkel-db.firebasestorage.app/o/casos-exito%2Fscada.gif?alt=media&token=851277ca-73a5-4761-a1b9-f037f29e7fdd",
      botones: [{ texto: "Avanzar", accion: 4 }],
    },
    {
      id: 4,
      titulo: "Fábrica + Grafana",
      texto:
        "El sistema Grafana recibe los datos del SCADA, los interpreta y muestra indicadores de rendimiento en tiempo real. Esto permite visualizar alarmas, tendencias y eficiencia de los equipos.",
      imagenFabrica: new URL("@/assets/images/simulador/fabrica.png", import.meta.url).href,
      imagenScada: new URL("@/assets/images/simulador/scada_monitor.png", import.meta.url).href,
      imagenGrafana: new URL("@/assets/images/simulador/grafana_monitor.png", import.meta.url).href,
      botones: [{ texto: "Ver Grafana", accion: 5 }],
    },
    {
      id: 5,
      titulo: "Grafana",
      texto:
        "Grafana permite visualizar métricas clave del proceso industrial en tableros dinámicos. Con esta herramienta es posible identificar oportunidades de mejora y detectar patrones de comportamiento en la planta.",
      imagen: new URL("@/assets/images/simulador/grafana.jpeg", import.meta.url).href,
      botones: [{ texto: "Avanzar", accion: 6 }],
    },
    {
      id: 6,
      titulo: "Animación Grafana",
      texto:
        "Aquí observamos cómo los datos del SCADA se transforman en gráficos dinámicos dentro de Grafana. La información es procesada y traducida en indicadores de eficiencia, energía y calidad del proceso.",
      imagen:
        "https://firebasestorage.googleapis.com/v0/b/frenkel-db.firebasestorage.app/o/casos-exito%2Fgrafana.gif?alt=media&token=cfc0eaaa-a12a-471b-840f-253bd7777058",
      botones: [{ texto: "Avanzar", accion: 7 }],
    },
    {
      id: 7,
      titulo: "Notificación de IA",
      texto:
        "El sistema inteligente analiza la información recolectada y detecta patrones anormales. A través de la Inteligencia Artificial, se envían notificaciones predictivas que previenen fallas o detenciones no planificadas.",
      imagenFabrica: new URL("@/assets/images/simulador/fabrica.png", import.meta.url).href,
      imagenScada: new URL("@/assets/images/simulador/scada_monitor.png", import.meta.url).href,
      imagenGrafana: new URL("@/assets/images/simulador/grafana_monitor.png", import.meta.url).href,
      imagenNotificacion: new URL("@/assets/images/simulador/notificacion.png", import.meta.url).href,
      botones: [{ texto: "Ver IA", accion: 8 }],
    },
    {
      id: 8,
      titulo: "Inteligencia Artificial",
      texto:
        "La Inteligencia Artificial (IA) aprende del comportamiento histórico de la planta y propone mejoras continuas. Gracias al aprendizaje automático, el sistema se adapta a las condiciones cambiantes y optimiza el rendimiento general.",
      animacion: new URL("@/assets/images/simulador/bocina.gif", import.meta.url).href,
      botones: [
        { texto: "Reiniciar", accion: 1 },
        { texto: "Quiero comenzar", accion: "contacto" },
      ],
      casosExito: [/* sin cambios */],
    },
  ],

  en: [
    {
      id: 3,
      titulo: "SCADA Animation",
      texto:
        "In this simulation, you’ll observe how sensor data is processed by the SCADA system and sent to the analytics layer. This represents the automated monitoring phase of the plant.",
      imagen:
        "https://firebasestorage.googleapis.com/v0/b/frenkel-db.firebasestorage.app/o/casos-exito%2Fscada.gif?alt=media&token=851277ca-73a5-4761-a1b9-f037f29e7fdd",
      botones: [{ texto: "Next", accion: 4 }],
    },
    {
      id: 6,
      titulo: "Grafana Animation",
      texto:
        "This stage shows how SCADA data is transformed into dynamic dashboards within Grafana. The information is processed and translated into efficiency, energy, and quality performance indicators.",
      imagen:
        "https://firebasestorage.googleapis.com/v0/b/frenkel-db.firebasestorage.app/o/casos-exito%2Fgrafana.gif?alt=media&token=cfc0eaaa-a12a-471b-840f-253bd7777058",
      botones: [{ texto: "Next", accion: 7 }],
    },
  ],

  de: [
    {
      id: 3,
      titulo: "SCADA-Animation",
      texto:
        "In dieser Simulation sehen Sie, wie die von Sensoren erfassten Daten vom SCADA-System verarbeitet und anschließend an das Analysesystem gesendet werden. Dies stellt die automatisierte Überwachungsphase der Anlage dar.",
      imagen:
        "https://firebasestorage.googleapis.com/v0/b/frenkel-db.firebasestorage.app/o/casos-exito%2Fscada.gif?alt=media&token=851277ca-73a5-4761-a1b9-f037f29e7fdd",
      botones: [{ texto: "Weiter", accion: 4 }],
    },
    {
      id: 6,
      titulo: "Grafana-Animation",
      texto:
        "Diese Phase zeigt, wie SCADA-Daten in dynamische Grafana-Dashboards umgewandelt werden. Die Informationen werden verarbeitet und in Kennzahlen für Effizienz, Energieverbrauch und Prozessqualität übersetzt.",
      imagen:
        "https://firebasestorage.googleapis.com/v0/b/frenkel-db.firebasestorage.app/o/casos-exito%2Fgrafana.gif?alt=media&token=cfc0eaaa-a12a-471b-840f-253bd7777058",
      botones: [{ texto: "Weiter", accion: 7 }],
    },
  ],
}

